// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  acceptPrivacyPolicy,
  addTeamMember,
  applyForJob,
  applyPlanOperation,
  archiveJob,
  bookingUnsubscribe,
  bookingWithdraw,
  bookSlot,
  bulkAssessmentIntake,
  bulkInterviewIntake,
  bulkScreeningIntake,
  checkAlreadyInSystem,
  completeCodingAssessment,
  completePrescreenConversation,
  confirmCreateJob,
  createCodingAssessmentRecordingSession,
  createInterviewPlan,
  createJob,
  createPartnerCredential,
  createScreenerPlan,
  createTenant,
  deleteApplicationCandidate,
  deleteDocument,
  evaluateScreenerApplication,
  evaluateScreenerJob,
  executeTaskTasksExecutePost,
  expandJobDescription,
  exportApplications,
  forceReleasePrescreenConversation,
  generateInkeepToken,
  generateInteractiveProblem,
  generateInterviewPlanRubric,
  generateInterviewShareToken,
  generateSectionCriteria,
  getActiveEmailTemplate,
  getApplication,
  getAssessmentApplications,
  getAssessmentConfig,
  getAssessmentRecordingUrl,
  getBookingConfig,
  getBookingIcs,
  getBookingSlots,
  getBookingStatus,
  getCachedSections,
  getCandidateIntakeValidationStatus,
  getCandidateInterview,
  getCodingAssessmentExecutionStatus,
  getCodingAssessmentPreview,
  getConsumptionReport,
  getCreateJobDraft,
  getCurrentTenant,
  getCurrentTenantPublic,
  getCurrentUser,
  getDocumentContent,
  getDocumentDownloadUrl,
  getExportOptions,
  getGreenhouseMetadata,
  getInterviewingCounts,
  getInterviewPlan,
  getInterviewPlanDraft,
  getInterviewPlanRubric,
  getInterviewResult,
  getJob,
  getJobAnalytics,
  getJobAnalyticsBatches,
  getJobAnalyticsExcel,
  getJobLoginContext,
  getListingFilterOptions,
  getMyJob,
  getMyPermissions,
  getPrescreenConversation,
  getPrescreenConversationDetail,
  getPrescreenConversations,
  getProblemTopics,
  getProctoringClipUrl,
  getPublicJob,
  getRecruiterInterview,
  getScreenerPlan,
  getScreeningApplication,
  getScreeningApplications,
  getSectionTimeLimits,
  getTenantById,
  getUsageAnalytics,
  getWorkflowAuditHistory,
  getWorkflowAvailableEvents,
  getWorkflowBulkAvailableEvents,
  globalCandidateSearch,
  greenhouseListTests,
  greenhouseRequestErrors,
  greenhouseSendTest,
  greenhouseTestStatus,
  inviteTenantMember,
  inviteToAssessment,
  inviteToInterview,
  listApplications,
  listCodingAssessmentSubmissions,
  listDocuments,
  listInterviewingApplications,
  listInterviewPlans,
  listInterviewsForJob,
  listJobs,
  listMyInterviews,
  listMyJobs,
  listPendingBookingInvites,
  listPublicJobs,
  listTeamMembers,
  listTenantMembers,
  listTenantRoles,
  listTenants,
  markCodingAssessmentEditorLoaded,
  type Options,
  parseCandidateResume,
  publishJob,
  questionGeneratorLlm,
  recordCodingAssessmentEvents,
  recordGreenhouseMetadata,
  recordProctoringFeedback,
  refineJdSelection,
  refineJobDescription,
  regenerateCaseStudy,
  removeTeamMember,
  removeTenantMember,
  requestReschedule,
  restoreDeclined,
  reviewReschedule,
  runCodingAssessmentCode,
  saveAssessmentConfig,
  saveAssessmentRequirements,
  saveCreateJobDraft,
  saveInterviewPlanDraft,
  sendBookingInvites,
  setIntakeMetadata,
  setSelectionStatus,
  singleAssessmentIntake,
  singleInterviewIntake,
  singleScreeningIntake,
  startCandidateIntakeValidation,
  startCodingAssessment,
  startPrescreenConversation,
  submitCodingAssessmentCode,
  suggestAssessmentDesign,
  suggestInteractiveConfig,
  suggestQuestions,
  suggestSubtopics,
  suggestTopics,
  syncCodingAssessmentDraft,
  triggerInterviewProctoring,
  triggerInterviewProctoringBulk,
  unpublishJob,
  updateCurrentTenant,
  updateCustomInstructions,
  updateInterviewPlanRubric,
  updateJob,
  updateLiveProctoring,
  updateOfflineProctoring,
  updateScreenerPlan,
  updateTeamMemberRole,
  updateTenantMemberRole,
  uploadJobDescription,
  uploadReferenceDocument,
  uploadResumeForApplication,
  upsertApplication,
  upsertBookingConfig,
  v2HealthHealthGet,
  workflowAssignReviewer,
  workflowBulkAssignByAddedBy,
  workflowBulkAssignReviewer,
  workflowBulkChangeDeadline,
  workflowBulkSendReminder,
  workflowBulkTransition,
  workflowSubmitHumanReview,
  workflowTransition,
} from '../sdk.gen';
import type {
  AcceptPrivacyPolicyData,
  AcceptPrivacyPolicyResponse,
  AddTeamMemberData,
  AddTeamMemberResult,
  ApplyForJobData,
  ApplyForJobResult,
  ApplyPlanOperationData,
  ApplyPlanOperationResult,
  ArchiveJobData,
  ArchiveJobResponse,
  BookingUnsubscribeData,
  BookingUnsubscribeResponse,
  BookingWithdrawData,
  BookingWithdrawResponse,
  BookSlotData,
  BookSlotResponse,
  BulkAssessmentIntakeData,
  BulkAssessmentIntakeResult,
  BulkInterviewIntakeData,
  BulkInterviewIntakeResult,
  BulkScreeningIntakeData,
  BulkScreeningIntakeResult,
  CheckAlreadyInSystemData,
  CheckAlreadyInSystemResult,
  CompleteCodingAssessmentData,
  CompleteCodingAssessmentResponse,
  CompletePrescreenConversationData,
  CompletePrescreenConversationResponse,
  ConfirmCreateJobData,
  ConfirmCreateJobResponse,
  CreateCodingAssessmentRecordingSessionData,
  CreateCodingAssessmentRecordingSessionResponse,
  CreateInterviewPlanData,
  CreateInterviewPlanResponse,
  CreateJobData,
  CreateJobResponse,
  CreatePartnerCredentialData,
  CreatePartnerCredentialResult,
  CreateScreenerPlanData,
  CreateScreenerPlanResponse,
  CreateTenantData,
  CreateTenantResponse,
  DeleteApplicationCandidateData,
  DeleteApplicationCandidateResponse,
  DeleteDocumentData,
  DeleteDocumentResponse,
  EvaluateScreenerApplicationData,
  EvaluateScreenerApplicationResponse,
  EvaluateScreenerJobData,
  EvaluateScreenerJobResponse,
  ExecuteTaskTasksExecutePostData,
  ExecuteTaskTasksExecutePostError,
  ExecuteTaskTasksExecutePostResponse,
  ExpandJobDescriptionData,
  ExpandJobDescriptionResponse,
  ExportApplicationsData,
  ForceReleasePrescreenConversationData,
  ForceReleasePrescreenConversationResponse,
  GenerateInkeepTokenData,
  GenerateInkeepTokenResponse,
  GenerateInteractiveProblemData,
  GenerateInteractiveProblemResponse,
  GenerateInterviewPlanRubricData,
  GenerateInterviewPlanRubricResponse,
  GenerateInterviewShareTokenData,
  GenerateInterviewShareTokenResponse,
  GenerateSectionCriteriaData,
  GenerateSectionCriteriaResponse,
  GetActiveEmailTemplateData,
  GetActiveEmailTemplateResponse,
  GetApplicationData,
  GetApplicationResponse,
  GetAssessmentApplicationsData,
  GetAssessmentApplicationsResponse,
  GetAssessmentConfigData,
  GetAssessmentConfigResult,
  GetAssessmentRecordingUrlData,
  GetAssessmentRecordingUrlResponse,
  GetBookingConfigData,
  GetBookingConfigResponse,
  GetBookingIcsData,
  GetBookingSlotsData,
  GetBookingSlotsResponse,
  GetBookingStatusData,
  GetBookingStatusResponse,
  GetCachedSectionsData,
  GetCachedSectionsResponse,
  GetCandidateIntakeValidationStatusData,
  GetCandidateIntakeValidationStatusResponse,
  GetCandidateInterviewData,
  GetCandidateInterviewResponse,
  GetCodingAssessmentExecutionStatusData,
  GetCodingAssessmentExecutionStatusResponse,
  GetCodingAssessmentPreviewData,
  GetCodingAssessmentPreviewResponse,
  GetConsumptionReportData,
  GetCreateJobDraftData,
  GetCreateJobDraftResponse,
  GetCurrentTenantData,
  GetCurrentTenantPublicData,
  GetCurrentTenantPublicResponse,
  GetCurrentTenantResponse,
  GetCurrentUserData,
  GetCurrentUserResponse,
  GetDocumentContentData,
  GetDocumentContentResponse,
  GetDocumentDownloadUrlData,
  GetDocumentDownloadUrlResponse,
  GetExportOptionsData,
  GetExportOptionsResponse,
  GetGreenhouseMetadataData,
  GetGreenhouseMetadataResponse,
  GetInterviewingCountsData,
  GetInterviewingCountsResponse,
  GetInterviewPlanData,
  GetInterviewPlanDraftData,
  GetInterviewPlanDraftResponse,
  GetInterviewPlanResponse,
  GetInterviewPlanRubricData,
  GetInterviewPlanRubricResponse,
  GetInterviewResultData,
  GetInterviewResultResponse,
  GetJobAnalyticsBatchesData,
  GetJobAnalyticsBatchesResponse,
  GetJobAnalyticsData,
  GetJobAnalyticsExcelData,
  GetJobAnalyticsResponse,
  GetJobData,
  GetJobLoginContextData,
  GetJobLoginContextResponse,
  GetJobResponse,
  GetListingFilterOptionsData,
  GetListingFilterOptionsResponse,
  GetMyJobData,
  GetMyJobResponse,
  GetMyPermissionsData,
  GetMyPermissionsResponse,
  GetPrescreenConversationData,
  GetPrescreenConversationDetailData,
  GetPrescreenConversationDetailResponse,
  GetPrescreenConversationResponse,
  GetPrescreenConversationsData,
  GetPrescreenConversationsResponse,
  GetProblemTopicsData,
  GetProblemTopicsResponse,
  GetProctoringClipUrlData,
  GetProctoringClipUrlResponse,
  GetPublicJobData,
  GetPublicJobResponse,
  GetRecruiterInterviewData,
  GetRecruiterInterviewResponse,
  GetScreenerPlanData,
  GetScreenerPlanResponse,
  GetScreeningApplicationData,
  GetScreeningApplicationResponse,
  GetScreeningApplicationsData,
  GetScreeningApplicationsResponse,
  GetSectionTimeLimitsData,
  GetSectionTimeLimitsResponse,
  GetTenantByIdData,
  GetTenantByIdResponse,
  GetUsageAnalyticsData,
  GetUsageAnalyticsResponse,
  GetWorkflowAuditHistoryData,
  GetWorkflowAuditHistoryResponse,
  GetWorkflowAvailableEventsData,
  GetWorkflowAvailableEventsResponse,
  GetWorkflowBulkAvailableEventsData,
  GetWorkflowBulkAvailableEventsResponse,
  GlobalCandidateSearchData,
  GlobalCandidateSearchResponse,
  GreenhouseListTestsData,
  GreenhouseListTestsResponse,
  GreenhouseRequestErrorsData,
  GreenhouseRequestErrorsResponse,
  GreenhouseSendTestData,
  GreenhouseSendTestResponse,
  GreenhouseTestStatusData,
  GreenhouseTestStatusResponse,
  InviteTenantMemberData,
  InviteTenantMemberResult,
  InviteToAssessmentData,
  InviteToAssessmentResult,
  InviteToInterviewData,
  InviteToInterviewResult,
  ListApplicationsData,
  ListApplicationsResult,
  ListCodingAssessmentSubmissionsData,
  ListCodingAssessmentSubmissionsResponse,
  ListDocumentsData,
  ListDocumentsResult,
  ListInterviewingApplicationsData,
  ListInterviewingApplicationsResult,
  ListInterviewPlansData,
  ListInterviewPlansResult,
  ListInterviewsForJobData,
  ListInterviewsForJobResponse,
  ListJobsData,
  ListJobsResult,
  ListMyInterviewsData,
  ListMyInterviewsResult,
  ListMyJobsData,
  ListMyJobsResult,
  ListPendingBookingInvitesData,
  ListPendingBookingInvitesResult,
  ListPublicJobsData,
  ListPublicJobsResult,
  ListTeamMembersData,
  ListTeamMembersResult,
  ListTenantMembersData,
  ListTenantMembersResult,
  ListTenantRolesData,
  ListTenantRolesResponse,
  ListTenantsData,
  ListTenantsResult,
  MarkCodingAssessmentEditorLoadedData,
  MarkCodingAssessmentEditorLoadedResponse,
  ParseCandidateResumeData,
  ParseCandidateResumeResponse,
  PublishJobData,
  PublishJobResponse,
  QuestionGeneratorLlmData,
  QuestionGeneratorLlmResponse,
  RecordCodingAssessmentEventsData,
  RecordCodingAssessmentEventsResponse,
  RecordGreenhouseMetadataData,
  RecordGreenhouseMetadataResponse,
  RecordProctoringFeedbackData,
  RecordProctoringFeedbackResult,
  RefineJdSelectionData,
  RefineJdSelectionResponse,
  RefineJobDescriptionData,
  RefineJobDescriptionResponse,
  RegenerateCaseStudyData,
  RegenerateCaseStudyResponse,
  RemoveTeamMemberData,
  RemoveTeamMemberResult,
  RemoveTenantMemberData,
  RemoveTenantMemberResult,
  RequestRescheduleData,
  RequestRescheduleResponse,
  RestoreDeclinedData,
  RestoreDeclinedResponse,
  ReviewRescheduleData,
  ReviewRescheduleResponse,
  RunCodingAssessmentCodeData,
  RunCodingAssessmentCodeResponse,
  SaveAssessmentConfigData,
  SaveAssessmentConfigResponse,
  SaveAssessmentRequirementsData,
  SaveAssessmentRequirementsResponse,
  SaveCreateJobDraftData,
  SaveCreateJobDraftResponse,
  SaveInterviewPlanDraftData,
  SaveInterviewPlanDraftResponse,
  SendBookingInvitesData,
  SendBookingInvitesResult,
  SetIntakeMetadataData,
  SetIntakeMetadataResponse,
  SetSelectionStatusData,
  SetSelectionStatusResponse,
  SingleAssessmentIntakeData,
  SingleAssessmentIntakeResult,
  SingleInterviewIntakeData,
  SingleInterviewIntakeResult,
  SingleScreeningIntakeData,
  SingleScreeningIntakeResult,
  StartCandidateIntakeValidationData,
  StartCandidateIntakeValidationResponse,
  StartCodingAssessmentData,
  StartCodingAssessmentResponse,
  StartPrescreenConversationData,
  StartPrescreenConversationResponse,
  SubmitCodingAssessmentCodeData,
  SubmitCodingAssessmentCodeResponse,
  SuggestAssessmentDesignData,
  SuggestAssessmentDesignResult,
  SuggestInteractiveConfigData,
  SuggestInteractiveConfigResponse,
  SuggestQuestionsData,
  SuggestQuestionsResponse,
  SuggestSubtopicsData,
  SuggestSubtopicsResponse,
  SuggestTopicsData,
  SuggestTopicsResponse,
  SyncCodingAssessmentDraftData,
  SyncCodingAssessmentDraftResponse,
  TriggerInterviewProctoringBulkData,
  TriggerInterviewProctoringBulkResponse,
  TriggerInterviewProctoringData,
  TriggerInterviewProctoringResponse,
  UnpublishJobData,
  UnpublishJobResponse,
  UpdateCurrentTenantData,
  UpdateCurrentTenantResponse,
  UpdateCustomInstructionsData,
  UpdateCustomInstructionsResponse,
  UpdateInterviewPlanRubricData,
  UpdateInterviewPlanRubricResponse,
  UpdateJobData,
  UpdateJobResponse,
  UpdateLiveProctoringData,
  UpdateLiveProctoringResponse,
  UpdateOfflineProctoringData,
  UpdateOfflineProctoringResponse,
  UpdateScreenerPlanData,
  UpdateScreenerPlanResponse,
  UpdateTeamMemberRoleData,
  UpdateTeamMemberRoleResult,
  UpdateTenantMemberRoleData,
  UpdateTenantMemberRoleResult,
  UploadJobDescriptionData,
  UploadJobDescriptionResult,
  UploadReferenceDocumentData,
  UploadReferenceDocumentResponse,
  UploadResumeForApplicationData,
  UploadResumeForApplicationResponse,
  UpsertApplicationData,
  UpsertApplicationResponse,
  UpsertBookingConfigData,
  UpsertBookingConfigResponse,
  V2HealthHealthGetData,
  V2HealthHealthGetResponse,
  WorkflowAssignReviewerData,
  WorkflowAssignReviewerResponse,
  WorkflowBulkAssignByAddedByData,
  WorkflowBulkAssignByAddedByResponse,
  WorkflowBulkAssignReviewerData,
  WorkflowBulkAssignReviewerResponse,
  WorkflowBulkChangeDeadlineData,
  WorkflowBulkChangeDeadlineResponse,
  WorkflowBulkSendReminderData,
  WorkflowBulkSendReminderResponse,
  WorkflowBulkTransitionData,
  WorkflowBulkTransitionResponse,
  WorkflowSubmitHumanReviewData,
  WorkflowSubmitHumanReviewResponse,
  WorkflowTransitionData,
  WorkflowTransitionResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getCurrentTenantPublicQueryKey = (
  options?: Options<GetCurrentTenantPublicData>,
) => createQueryKey('getCurrentTenantPublic', options);

/**
 * Get current tenant (public)
 *
 * Returns non-sensitive tenant identity — safe to call before the user has signed in. For full detail including settings, see `get_current_tenant`.
 */
export const getCurrentTenantPublicOptions = (
  options?: Options<GetCurrentTenantPublicData>,
) =>
  queryOptions<
    GetCurrentTenantPublicResponse,
    DefaultError,
    GetCurrentTenantPublicResponse,
    ReturnType<typeof getCurrentTenantPublicQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentTenantPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentTenantPublicQueryKey(options),
  });

export const getCurrentTenantQueryKey = (
  options?: Options<GetCurrentTenantData>,
) => createQueryKey('getCurrentTenant', options);

/**
 * Get the current tenant
 *
 * Returns full tenant detail including configuration and settings.
 */
export const getCurrentTenantOptions = (
  options?: Options<GetCurrentTenantData>,
) =>
  queryOptions<
    GetCurrentTenantResponse,
    DefaultError,
    GetCurrentTenantResponse,
    ReturnType<typeof getCurrentTenantQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentTenantQueryKey(options),
  });

/**
 * Update the current tenant
 *
 * Updates the caller's own tenant profile and self-service settings. Platform-managed fields are not exposed and cannot be changed through this endpoint.
 */
export const updateCurrentTenantMutation = (
  options?: Partial<Options<UpdateCurrentTenantData>>,
): UseMutationOptions<
  UpdateCurrentTenantResponse,
  DefaultError,
  Options<UpdateCurrentTenantData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCurrentTenantResponse,
    DefaultError,
    Options<UpdateCurrentTenantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCurrentTenant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMyPermissionsQueryKey = (
  options?: Options<GetMyPermissionsData>,
) => createQueryKey('getMyPermissions', options);

/**
 * Get caller's permissions for the current tenant
 *
 * Returns the authenticated user's tenant-level permissions, per-job permissions, and superuser flag. Account admins (manage_tenant_jobs) receive an empty job_permissions list — the frontend derives full job access from that permission.
 */
export const getMyPermissionsOptions = (
  options?: Options<GetMyPermissionsData>,
) =>
  queryOptions<
    GetMyPermissionsResponse,
    DefaultError,
    GetMyPermissionsResponse,
    ReturnType<typeof getMyPermissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyPermissionsQueryKey(options),
  });

export const listTenantsQueryKey = (options?: Options<ListTenantsData>) =>
  createQueryKey('listTenants', options);

/**
 * List all tenants
 *
 * Returns all tenants, oldest first. Admin only.
 */
export const listTenantsOptions = (options?: Options<ListTenantsData>) =>
  queryOptions<
    ListTenantsResult,
    DefaultError,
    ListTenantsResult,
    ReturnType<typeof listTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenants({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantsQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const listTenantsInfiniteQueryKey = (
  options?: Options<ListTenantsData>,
): QueryKey<Options<ListTenantsData>> =>
  createQueryKey('listTenants', options, true);

/**
 * List all tenants
 *
 * Returns all tenants, oldest first. Admin only.
 */
export const listTenantsInfiniteOptions = (
  options?: Options<ListTenantsData>,
) =>
  infiniteQueryOptions<
    ListTenantsResult,
    DefaultError,
    InfiniteData<ListTenantsResult>,
    QueryKey<Options<ListTenantsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListTenantsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTenantsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTenants({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTenantsInfiniteQueryKey(options),
    },
  );

/**
 * Create a new tenant
 *
 * Creates a tenant and makes the caller its first admin. Fails if the domain is already taken. Admin only.
 */
export const createTenantMutation = (
  options?: Partial<Options<CreateTenantData>>,
): UseMutationOptions<
  CreateTenantResponse,
  DefaultError,
  Options<CreateTenantData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTenantResponse,
    DefaultError,
    Options<CreateTenantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTenant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTenantByIdQueryKey = (options: Options<GetTenantByIdData>) =>
  createQueryKey('getTenantById', options);

/**
 * Get a tenant by id
 *
 * Admin only.
 */
export const getTenantByIdOptions = (options: Options<GetTenantByIdData>) =>
  queryOptions<
    GetTenantByIdResponse,
    DefaultError,
    GetTenantByIdResponse,
    ReturnType<typeof getTenantByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTenantById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTenantByIdQueryKey(options),
  });

export const listTenantMembersQueryKey = (
  options?: Options<ListTenantMembersData>,
) => createQueryKey('listTenantMembers', options);

/**
 * List Tenant Members
 */
export const listTenantMembersOptions = (
  options?: Options<ListTenantMembersData>,
) =>
  queryOptions<
    ListTenantMembersResult,
    DefaultError,
    ListTenantMembersResult,
    ReturnType<typeof listTenantMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenantMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantMembersQueryKey(options),
  });

export const listTenantMembersInfiniteQueryKey = (
  options?: Options<ListTenantMembersData>,
): QueryKey<Options<ListTenantMembersData>> =>
  createQueryKey('listTenantMembers', options, true);

/**
 * List Tenant Members
 */
export const listTenantMembersInfiniteOptions = (
  options?: Options<ListTenantMembersData>,
) =>
  infiniteQueryOptions<
    ListTenantMembersResult,
    DefaultError,
    InfiniteData<ListTenantMembersResult>,
    QueryKey<Options<ListTenantMembersData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListTenantMembersData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTenantMembersData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTenantMembers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTenantMembersInfiniteQueryKey(options),
    },
  );

/**
 * Invite Tenant Member
 */
export const inviteTenantMemberMutation = (
  options?: Partial<Options<InviteTenantMemberData>>,
): UseMutationOptions<
  InviteTenantMemberResult,
  DefaultError,
  Options<InviteTenantMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteTenantMemberResult,
    DefaultError,
    Options<InviteTenantMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteTenantMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Tenant Member Role
 */
export const updateTenantMemberRoleMutation = (
  options?: Partial<Options<UpdateTenantMemberRoleData>>,
): UseMutationOptions<
  UpdateTenantMemberRoleResult,
  DefaultError,
  Options<UpdateTenantMemberRoleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTenantMemberRoleResult,
    DefaultError,
    Options<UpdateTenantMemberRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTenantMemberRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Tenant Member
 */
export const removeTenantMemberMutation = (
  options?: Partial<Options<RemoveTenantMemberData>>,
): UseMutationOptions<
  RemoveTenantMemberResult,
  DefaultError,
  Options<RemoveTenantMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveTenantMemberResult,
    DefaultError,
    Options<RemoveTenantMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeTenantMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTenantRolesQueryKey = (
  options?: Options<ListTenantRolesData>,
) => createQueryKey('listTenantRoles', options);

/**
 * List Tenant Roles
 */
export const listTenantRolesOptions = (
  options?: Options<ListTenantRolesData>,
) =>
  queryOptions<
    ListTenantRolesResponse,
    DefaultError,
    ListTenantRolesResponse,
    ReturnType<typeof listTenantRolesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenantRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantRolesQueryKey(options),
  });

export const getApplicationQueryKey = (options: Options<GetApplicationData>) =>
  createQueryKey('getApplication', options);

/**
 * Get an application by id
 */
export const getApplicationOptions = (options: Options<GetApplicationData>) =>
  queryOptions<
    GetApplicationResponse,
    DefaultError,
    GetApplicationResponse,
    ReturnType<typeof getApplicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApplication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApplicationQueryKey(options),
  });

export const listApplicationsQueryKey = (
  options: Options<ListApplicationsData>,
) => createQueryKey('listApplications', options);

/**
 * List applications for a job
 */
export const listApplicationsOptions = (
  options: Options<ListApplicationsData>,
) =>
  queryOptions<
    ListApplicationsResult,
    DefaultError,
    ListApplicationsResult,
    ReturnType<typeof listApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listApplicationsQueryKey(options),
  });

export const listApplicationsInfiniteQueryKey = (
  options: Options<ListApplicationsData>,
): QueryKey<Options<ListApplicationsData>> =>
  createQueryKey('listApplications', options, true);

/**
 * List applications for a job
 */
export const listApplicationsInfiniteOptions = (
  options: Options<ListApplicationsData>,
) =>
  infiniteQueryOptions<
    ListApplicationsResult,
    DefaultError,
    InfiniteData<ListApplicationsResult>,
    QueryKey<Options<ListApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listApplicationsInfiniteQueryKey(options),
    },
  );

export const listInterviewingApplicationsQueryKey = (
  options: Options<ListInterviewingApplicationsData>,
) => createQueryKey('listInterviewingApplications', options);

/**
 * Paginated row list for the Applications-v2 page
 */
export const listInterviewingApplicationsOptions = (
  options: Options<ListInterviewingApplicationsData>,
) =>
  queryOptions<
    ListInterviewingApplicationsResult,
    DefaultError,
    ListInterviewingApplicationsResult,
    ReturnType<typeof listInterviewingApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewingApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewingApplicationsQueryKey(options),
  });

export const listInterviewingApplicationsInfiniteQueryKey = (
  options: Options<ListInterviewingApplicationsData>,
): QueryKey<Options<ListInterviewingApplicationsData>> =>
  createQueryKey('listInterviewingApplications', options, true);

/**
 * Paginated row list for the Applications-v2 page
 */
export const listInterviewingApplicationsInfiniteOptions = (
  options: Options<ListInterviewingApplicationsData>,
) =>
  infiniteQueryOptions<
    ListInterviewingApplicationsResult,
    DefaultError,
    InfiniteData<ListInterviewingApplicationsResult>,
    QueryKey<Options<ListInterviewingApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListInterviewingApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListInterviewingApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInterviewingApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listInterviewingApplicationsInfiniteQueryKey(options),
    },
  );

export const globalCandidateSearchQueryKey = (
  options?: Options<GlobalCandidateSearchData>,
) => createQueryKey('globalCandidateSearch', options);

/**
 * Cross-job candidate search (per-job RBAC scoped)
 */
export const globalCandidateSearchOptions = (
  options?: Options<GlobalCandidateSearchData>,
) =>
  queryOptions<
    GlobalCandidateSearchResponse,
    DefaultError,
    GlobalCandidateSearchResponse,
    ReturnType<typeof globalCandidateSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await globalCandidateSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: globalCandidateSearchQueryKey(options),
  });

export const globalCandidateSearchInfiniteQueryKey = (
  options?: Options<GlobalCandidateSearchData>,
): QueryKey<Options<GlobalCandidateSearchData>> =>
  createQueryKey('globalCandidateSearch', options, true);

/**
 * Cross-job candidate search (per-job RBAC scoped)
 */
export const globalCandidateSearchInfiniteOptions = (
  options?: Options<GlobalCandidateSearchData>,
) =>
  infiniteQueryOptions<
    GlobalCandidateSearchResponse,
    DefaultError,
    InfiniteData<GlobalCandidateSearchResponse>,
    QueryKey<Options<GlobalCandidateSearchData>>,
    | number
    | Pick<
        QueryKey<Options<GlobalCandidateSearchData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GlobalCandidateSearchData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await globalCandidateSearch({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: globalCandidateSearchInfiniteQueryKey(options),
    },
  );

export const getInterviewingCountsQueryKey = (
  options: Options<GetInterviewingCountsData>,
) => createQueryKey('getInterviewingCounts', options);

/**
 * Aggregate bucket + board counts for the Applications-v2 page
 */
export const getInterviewingCountsOptions = (
  options: Options<GetInterviewingCountsData>,
) =>
  queryOptions<
    GetInterviewingCountsResponse,
    DefaultError,
    GetInterviewingCountsResponse,
    ReturnType<typeof getInterviewingCountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewingCounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewingCountsQueryKey(options),
  });

export const getListingFilterOptionsQueryKey = (
  options: Options<GetListingFilterOptionsData>,
) => createQueryKey('getListingFilterOptions', options);

/**
 * Selectable values (batches) for the Applications-v2 listing filters
 */
export const getListingFilterOptionsOptions = (
  options: Options<GetListingFilterOptionsData>,
) =>
  queryOptions<
    GetListingFilterOptionsResponse,
    DefaultError,
    GetListingFilterOptionsResponse,
    ReturnType<typeof getListingFilterOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getListingFilterOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getListingFilterOptionsQueryKey(options),
  });

export const getActiveEmailTemplateQueryKey = (
  options: Options<GetActiveEmailTemplateData>,
) => createQueryKey('getActiveEmailTemplate', options);

/**
 * Most-recent active email template for a (job, trigger_event) pair
 */
export const getActiveEmailTemplateOptions = (
  options: Options<GetActiveEmailTemplateData>,
) =>
  queryOptions<
    GetActiveEmailTemplateResponse,
    DefaultError,
    GetActiveEmailTemplateResponse,
    ReturnType<typeof getActiveEmailTemplateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveEmailTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveEmailTemplateQueryKey(options),
  });

export const getGreenhouseMetadataQueryKey = (
  options: Options<GetGreenhouseMetadataData>,
) => createQueryKey('getGreenhouseMetadata', options);

/**
 * Get Greenhouse ATS metadata for an application
 */
export const getGreenhouseMetadataOptions = (
  options: Options<GetGreenhouseMetadataData>,
) =>
  queryOptions<
    GetGreenhouseMetadataResponse,
    DefaultError,
    GetGreenhouseMetadataResponse,
    ReturnType<typeof getGreenhouseMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGreenhouseMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGreenhouseMetadataQueryKey(options),
  });

/**
 * Record Greenhouse ATS callback metadata on an application
 */
export const recordGreenhouseMetadataMutation = (
  options?: Partial<Options<RecordGreenhouseMetadataData>>,
): UseMutationOptions<
  RecordGreenhouseMetadataResponse,
  DefaultError,
  Options<RecordGreenhouseMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordGreenhouseMetadataResponse,
    DefaultError,
    Options<RecordGreenhouseMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordGreenhouseMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const exportApplicationsQueryKey = (
  options: Options<ExportApplicationsData>,
) => createQueryKey('exportApplications', options);

/**
 * Export applications as XLSX, CSV, or JSON
 */
export const exportApplicationsOptions = (
  options: Options<ExportApplicationsData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof exportApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exportApplicationsQueryKey(options),
  });

export const getExportOptionsQueryKey = (
  options: Options<GetExportOptionsData>,
) => createQueryKey('getExportOptions', options);

/**
 * Get export modal option counts
 */
export const getExportOptionsOptions = (
  options: Options<GetExportOptionsData>,
) =>
  queryOptions<
    GetExportOptionsResponse,
    DefaultError,
    GetExportOptionsResponse,
    ReturnType<typeof getExportOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExportOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExportOptionsQueryKey(options),
  });

/**
 * Create or retrieve an application for a (job, user) pair
 */
export const upsertApplicationMutation = (
  options?: Partial<Options<UpsertApplicationData>>,
): UseMutationOptions<
  UpsertApplicationResponse,
  DefaultError,
  Options<UpsertApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertApplicationResponse,
    DefaultError,
    Options<UpsertApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set intake (pre-interview) metadata on an application
 */
export const setIntakeMetadataMutation = (
  options?: Partial<Options<SetIntakeMetadataData>>,
): UseMutationOptions<
  SetIntakeMetadataResponse,
  DefaultError,
  Options<SetIntakeMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    SetIntakeMetadataResponse,
    DefaultError,
    Options<SetIntakeMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setIntakeMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set the AI selection status on an application
 */
export const setSelectionStatusMutation = (
  options?: Partial<Options<SetSelectionStatusData>>,
): UseMutationOptions<
  SetSelectionStatusResponse,
  DefaultError,
  Options<SetSelectionStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    SetSelectionStatusResponse,
    DefaultError,
    Options<SetSelectionStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setSelectionStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listJobsQueryKey = (options?: Options<ListJobsData>) =>
  createQueryKey('listJobs', options);

/**
 * List jobs
 */
export const listJobsOptions = (options?: Options<ListJobsData>) =>
  queryOptions<
    ListJobsResult,
    DefaultError,
    ListJobsResult,
    ReturnType<typeof listJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listJobsQueryKey(options),
  });

export const listJobsInfiniteQueryKey = (
  options?: Options<ListJobsData>,
): QueryKey<Options<ListJobsData>> => createQueryKey('listJobs', options, true);

/**
 * List jobs
 */
export const listJobsInfiniteOptions = (options?: Options<ListJobsData>) =>
  infiniteQueryOptions<
    ListJobsResult,
    DefaultError,
    InfiniteData<ListJobsResult>,
    QueryKey<Options<ListJobsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListJobsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListJobsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listJobs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listJobsInfiniteQueryKey(options),
    },
  );

/**
 * Update a job
 */
export const updateJobMutation = (
  options?: Partial<Options<UpdateJobData>>,
): UseMutationOptions<
  UpdateJobResponse,
  DefaultError,
  Options<UpdateJobData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateJobResponse,
    DefaultError,
    Options<UpdateJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new job
 */
export const createJobMutation = (
  options?: Partial<Options<CreateJobData>>,
): UseMutationOptions<
  CreateJobResponse,
  DefaultError,
  Options<CreateJobData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateJobResponse,
    DefaultError,
    Options<CreateJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJobQueryKey = (options: Options<GetJobData>) =>
  createQueryKey('getJob', options);

/**
 * Get a job by id
 */
export const getJobOptions = (options: Options<GetJobData>) =>
  queryOptions<
    GetJobResponse,
    DefaultError,
    GetJobResponse,
    ReturnType<typeof getJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobQueryKey(options),
  });

export const listDocumentsQueryKey = (options: Options<ListDocumentsData>) =>
  createQueryKey('listDocuments', options);

/**
 * List documents attached to a job
 */
export const listDocumentsOptions = (options: Options<ListDocumentsData>) =>
  queryOptions<
    ListDocumentsResult,
    DefaultError,
    ListDocumentsResult,
    ReturnType<typeof listDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDocumentsQueryKey(options),
  });

export const getDocumentDownloadUrlQueryKey = (
  options: Options<GetDocumentDownloadUrlData>,
) => createQueryKey('getDocumentDownloadUrl', options);

/**
 * Get a signed download URL for a document
 */
export const getDocumentDownloadUrlOptions = (
  options: Options<GetDocumentDownloadUrlData>,
) =>
  queryOptions<
    GetDocumentDownloadUrlResponse,
    DefaultError,
    GetDocumentDownloadUrlResponse,
    ReturnType<typeof getDocumentDownloadUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentDownloadUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentDownloadUrlQueryKey(options),
  });

export const getDocumentContentQueryKey = (
  options: Options<GetDocumentContentData>,
) => createQueryKey('getDocumentContent', options);

/**
 * Get the text content of a document
 */
export const getDocumentContentOptions = (
  options: Options<GetDocumentContentData>,
) =>
  queryOptions<
    GetDocumentContentResponse,
    DefaultError,
    GetDocumentContentResponse,
    ReturnType<typeof getDocumentContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentContentQueryKey(options),
  });

/**
 * Archive (soft-delete) a job
 */
export const archiveJobMutation = (
  options?: Partial<Options<ArchiveJobData>>,
): UseMutationOptions<
  ArchiveJobResponse,
  DefaultError,
  Options<ArchiveJobData>
> => {
  const mutationOptions: UseMutationOptions<
    ArchiveJobResponse,
    DefaultError,
    Options<ArchiveJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Publish a job
 */
export const publishJobMutation = (
  options?: Partial<Options<PublishJobData>>,
): UseMutationOptions<
  PublishJobResponse,
  DefaultError,
  Options<PublishJobData>
> => {
  const mutationOptions: UseMutationOptions<
    PublishJobResponse,
    DefaultError,
    Options<PublishJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unpublish a job
 */
export const unpublishJobMutation = (
  options?: Partial<Options<UnpublishJobData>>,
): UseMutationOptions<
  UnpublishJobResponse,
  DefaultError,
  Options<UnpublishJobData>
> => {
  const mutationOptions: UseMutationOptions<
    UnpublishJobResponse,
    DefaultError,
    Options<UnpublishJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a reference document to a job
 */
export const uploadReferenceDocumentMutation = (
  options?: Partial<Options<UploadReferenceDocumentData>>,
): UseMutationOptions<
  UploadReferenceDocumentResponse,
  DefaultError,
  Options<UploadReferenceDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadReferenceDocumentResponse,
    DefaultError,
    Options<UploadReferenceDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadReferenceDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a job description document — stores to GCS and extracts text
 */
export const uploadJobDescriptionMutation = (
  options?: Partial<Options<UploadJobDescriptionData>>,
): UseMutationOptions<
  UploadJobDescriptionResult,
  DefaultError,
  Options<UploadJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadJobDescriptionResult,
    DefaultError,
    Options<UploadJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a document from a job
 */
export const deleteDocumentMutation = (
  options?: Partial<Options<DeleteDocumentData>>,
): UseMutationOptions<
  DeleteDocumentResponse,
  DefaultError,
  Options<DeleteDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteDocumentResponse,
    DefaultError,
    Options<DeleteDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update live proctoring settings for a job
 */
export const updateLiveProctoringMutation = (
  options?: Partial<Options<UpdateLiveProctoringData>>,
): UseMutationOptions<
  UpdateLiveProctoringResponse,
  DefaultError,
  Options<UpdateLiveProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLiveProctoringResponse,
    DefaultError,
    Options<UpdateLiveProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLiveProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update offline proctoring settings for a job
 */
export const updateOfflineProctoringMutation = (
  options?: Partial<Options<UpdateOfflineProctoringData>>,
): UseMutationOptions<
  UpdateOfflineProctoringResponse,
  DefaultError,
  Options<UpdateOfflineProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateOfflineProctoringResponse,
    DefaultError,
    Options<UpdateOfflineProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOfflineProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Replace the custom candidate instructions for a job (auto-instructions preserved)
 */
export const updateCustomInstructionsMutation = (
  options?: Partial<Options<UpdateCustomInstructionsData>>,
): UseMutationOptions<
  UpdateCustomInstructionsResponse,
  DefaultError,
  Options<UpdateCustomInstructionsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCustomInstructionsResponse,
    DefaultError,
    Options<UpdateCustomInstructionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCustomInstructions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookingConfigQueryKey = (
  options: Options<GetBookingConfigData>,
) => createQueryKey('getBookingConfig', options);

/**
 * Get Booking Config
 */
export const getBookingConfigOptions = (
  options: Options<GetBookingConfigData>,
) =>
  queryOptions<
    GetBookingConfigResponse,
    DefaultError,
    GetBookingConfigResponse,
    ReturnType<typeof getBookingConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingConfigQueryKey(options),
  });

/**
 * Upsert Booking Config
 */
export const upsertBookingConfigMutation = (
  options?: Partial<Options<UpsertBookingConfigData>>,
): UseMutationOptions<
  UpsertBookingConfigResponse,
  DefaultError,
  Options<UpsertBookingConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertBookingConfigResponse,
    DefaultError,
    Options<UpsertBookingConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertBookingConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookingSlotsQueryKey = (
  options: Options<GetBookingSlotsData>,
) => createQueryKey('getBookingSlots', options);

/**
 * Get Booking Slots
 */
export const getBookingSlotsOptions = (options: Options<GetBookingSlotsData>) =>
  queryOptions<
    GetBookingSlotsResponse,
    DefaultError,
    GetBookingSlotsResponse,
    ReturnType<typeof getBookingSlotsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingSlots({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingSlotsQueryKey(options),
  });

export const getBookingStatusQueryKey = (
  options?: Options<GetBookingStatusData>,
) => createQueryKey('getBookingStatus', options);

/**
 * Get Booking Status
 *
 * Booking status as a list. Pass ``job_id`` for a whole job's pipeline, or ``interview_id``
 * for one interview (returned as a single-item list). Exactly one of the two is required.
 *
 * ``interview_ids`` scopes a job read to the page the caller renders, and is required with
 * ``job_id``: unscoped, the response carries a row per candidate on the job, which is thousands on
 * the largest ones, and the pipeline re-reads on every window focus. It applies only to a
 * ``job_id`` read, and is rejected rather than ignored alongside ``interview_id``.
 */
export const getBookingStatusOptions = (
  options?: Options<GetBookingStatusData>,
) =>
  queryOptions<
    GetBookingStatusResponse,
    DefaultError,
    GetBookingStatusResponse,
    ReturnType<typeof getBookingStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingStatusQueryKey(options),
  });

export const listPendingBookingInvitesQueryKey = (
  options: Options<ListPendingBookingInvitesData>,
) => createQueryKey('listPendingBookingInvites', options);

/**
 * List Pending Booking Invites
 *
 * Candidates invited before Calendar Booking was enabled who still hold no booking link.
 */
export const listPendingBookingInvitesOptions = (
  options: Options<ListPendingBookingInvitesData>,
) =>
  queryOptions<
    ListPendingBookingInvitesResult,
    DefaultError,
    ListPendingBookingInvitesResult,
    ReturnType<typeof listPendingBookingInvitesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPendingBookingInvites({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPendingBookingInvitesQueryKey(options),
  });

export const listPendingBookingInvitesInfiniteQueryKey = (
  options: Options<ListPendingBookingInvitesData>,
): QueryKey<Options<ListPendingBookingInvitesData>> =>
  createQueryKey('listPendingBookingInvites', options, true);

/**
 * List Pending Booking Invites
 *
 * Candidates invited before Calendar Booking was enabled who still hold no booking link.
 */
export const listPendingBookingInvitesInfiniteOptions = (
  options: Options<ListPendingBookingInvitesData>,
) =>
  infiniteQueryOptions<
    ListPendingBookingInvitesResult,
    DefaultError,
    InfiniteData<ListPendingBookingInvitesResult>,
    QueryKey<Options<ListPendingBookingInvitesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListPendingBookingInvitesData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListPendingBookingInvitesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPendingBookingInvites({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listPendingBookingInvitesInfiniteQueryKey(options),
    },
  );

export const getBookingIcsQueryKey = (options: Options<GetBookingIcsData>) =>
  createQueryKey('getBookingIcs', options);

/**
 * Get Booking Ics
 */
export const getBookingIcsOptions = (options: Options<GetBookingIcsData>) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getBookingIcsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingIcs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingIcsQueryKey(options),
  });

/**
 * Book Slot
 */
export const bookSlotMutation = (
  options?: Partial<Options<BookSlotData>>,
): UseMutationOptions<
  BookSlotResponse,
  DefaultError,
  Options<BookSlotData>
> => {
  const mutationOptions: UseMutationOptions<
    BookSlotResponse,
    DefaultError,
    Options<BookSlotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookSlot({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Reschedule
 */
export const requestRescheduleMutation = (
  options?: Partial<Options<RequestRescheduleData>>,
): UseMutationOptions<
  RequestRescheduleResponse,
  DefaultError,
  Options<RequestRescheduleData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestRescheduleResponse,
    DefaultError,
    Options<RequestRescheduleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestReschedule({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Review Reschedule
 */
export const reviewRescheduleMutation = (
  options?: Partial<Options<ReviewRescheduleData>>,
): UseMutationOptions<
  ReviewRescheduleResponse,
  DefaultError,
  Options<ReviewRescheduleData>
> => {
  const mutationOptions: UseMutationOptions<
    ReviewRescheduleResponse,
    DefaultError,
    Options<ReviewRescheduleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reviewReschedule({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Declined
 */
export const restoreDeclinedMutation = (
  options?: Partial<Options<RestoreDeclinedData>>,
): UseMutationOptions<
  RestoreDeclinedResponse,
  DefaultError,
  Options<RestoreDeclinedData>
> => {
  const mutationOptions: UseMutationOptions<
    RestoreDeclinedResponse,
    DefaultError,
    Options<RestoreDeclinedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restoreDeclined({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Booking Invites
 *
 * Send the booking invite to candidates who were invited before booking was enabled.
 */
export const sendBookingInvitesMutation = (
  options?: Partial<Options<SendBookingInvitesData>>,
): UseMutationOptions<
  SendBookingInvitesResult,
  DefaultError,
  Options<SendBookingInvitesData>
> => {
  const mutationOptions: UseMutationOptions<
    SendBookingInvitesResult,
    DefaultError,
    Options<SendBookingInvitesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendBookingInvites({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Booking Unsubscribe
 */
export const bookingUnsubscribeMutation = (
  options?: Partial<Options<BookingUnsubscribeData>>,
): UseMutationOptions<
  BookingUnsubscribeResponse,
  DefaultError,
  Options<BookingUnsubscribeData>
> => {
  const mutationOptions: UseMutationOptions<
    BookingUnsubscribeResponse,
    DefaultError,
    Options<BookingUnsubscribeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookingUnsubscribe({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Booking Withdraw
 */
export const bookingWithdrawMutation = (
  options?: Partial<Options<BookingWithdrawData>>,
): UseMutationOptions<
  BookingWithdrawResponse,
  DefaultError,
  Options<BookingWithdrawData>
> => {
  const mutationOptions: UseMutationOptions<
    BookingWithdrawResponse,
    DefaultError,
    Options<BookingWithdrawData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookingWithdraw({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTeamMembersQueryKey = (
  options: Options<ListTeamMembersData>,
) => createQueryKey('listTeamMembers', options);

/**
 * List Team Members
 */
export const listTeamMembersOptions = (options: Options<ListTeamMembersData>) =>
  queryOptions<
    ListTeamMembersResult,
    DefaultError,
    ListTeamMembersResult,
    ReturnType<typeof listTeamMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeamMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTeamMembersQueryKey(options),
  });

/**
 * Add Team Member
 */
export const addTeamMemberMutation = (
  options?: Partial<Options<AddTeamMemberData>>,
): UseMutationOptions<
  AddTeamMemberResult,
  DefaultError,
  Options<AddTeamMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    AddTeamMemberResult,
    DefaultError,
    Options<AddTeamMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Team Member Role
 */
export const updateTeamMemberRoleMutation = (
  options?: Partial<Options<UpdateTeamMemberRoleData>>,
): UseMutationOptions<
  UpdateTeamMemberRoleResult,
  DefaultError,
  Options<UpdateTeamMemberRoleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTeamMemberRoleResult,
    DefaultError,
    Options<UpdateTeamMemberRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTeamMemberRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Team Member
 */
export const removeTeamMemberMutation = (
  options?: Partial<Options<RemoveTeamMemberData>>,
): UseMutationOptions<
  RemoveTeamMemberResult,
  DefaultError,
  Options<RemoveTeamMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveTeamMemberResult,
    DefaultError,
    Options<RemoveTeamMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSectionTimeLimitsQueryKey = (
  options?: Options<GetSectionTimeLimitsData>,
) => createQueryKey('getSectionTimeLimits', options);

/**
 * Get per-section duration limits
 *
 * Returns the duration floor, ceiling, default, and control mode for each section type. The frontend fetches this once per session to render the correct duration widget.
 */
export const getSectionTimeLimitsOptions = (
  options?: Options<GetSectionTimeLimitsData>,
) =>
  queryOptions<
    GetSectionTimeLimitsResponse,
    DefaultError,
    GetSectionTimeLimitsResponse,
    ReturnType<typeof getSectionTimeLimitsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSectionTimeLimits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSectionTimeLimitsQueryKey(options),
  });

export const listInterviewPlansQueryKey = (
  options: Options<ListInterviewPlansData>,
) => createQueryKey('listInterviewPlans', options);

/**
 * List interview plans for a job
 */
export const listInterviewPlansOptions = (
  options: Options<ListInterviewPlansData>,
) =>
  queryOptions<
    ListInterviewPlansResult,
    DefaultError,
    ListInterviewPlansResult,
    ReturnType<typeof listInterviewPlansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewPlans({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewPlansQueryKey(options),
  });

export const getInterviewPlanQueryKey = (
  options: Options<GetInterviewPlanData>,
) => createQueryKey('getInterviewPlan', options);

/**
 * Get an interview plan
 */
export const getInterviewPlanOptions = (
  options: Options<GetInterviewPlanData>,
) =>
  queryOptions<
    GetInterviewPlanResponse,
    DefaultError,
    GetInterviewPlanResponse,
    ReturnType<typeof getInterviewPlanQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlan({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanQueryKey(options),
  });

export const getCachedSectionsQueryKey = (
  options: Options<GetCachedSectionsData>,
) => createQueryKey('getCachedSections', options);

/**
 * Get cached section library for a job
 */
export const getCachedSectionsOptions = (
  options: Options<GetCachedSectionsData>,
) =>
  queryOptions<
    GetCachedSectionsResponse,
    DefaultError,
    GetCachedSectionsResponse,
    ReturnType<typeof getCachedSectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCachedSections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCachedSectionsQueryKey(options),
  });

export const getInterviewPlanRubricQueryKey = (
  options: Options<GetInterviewPlanRubricData>,
) => createQueryKey('getInterviewPlanRubric', options);

/**
 * Get the evaluation rubric for an interview plan
 *
 * Returns the stored rubric. Returns 404 if no rubric has been generated yet — call POST /interview-plans/rubric/generate to create one.
 */
export const getInterviewPlanRubricOptions = (
  options: Options<GetInterviewPlanRubricData>,
) =>
  queryOptions<
    GetInterviewPlanRubricResponse,
    DefaultError,
    GetInterviewPlanRubricResponse,
    ReturnType<typeof getInterviewPlanRubricQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlanRubric({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanRubricQueryKey(options),
  });

export const getInterviewPlanDraftQueryKey = (
  options: Options<GetInterviewPlanDraftData>,
) => createQueryKey('getInterviewPlanDraft', options);

/**
 * Get the planner wizard draft state for a job
 *
 * Returns wizard fields persisted on the Job row plus derived `current_step` and `is_locked`. Always returns 200 — empty/default values if the user hasn't started the wizard yet. `is_locked=true` once a plan exists for the job (draft becomes read-only).
 */
export const getInterviewPlanDraftOptions = (
  options: Options<GetInterviewPlanDraftData>,
) =>
  queryOptions<
    GetInterviewPlanDraftResponse,
    DefaultError,
    GetInterviewPlanDraftResponse,
    ReturnType<typeof getInterviewPlanDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlanDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanDraftQueryKey(options),
  });

/**
 * Apply an operation to an interview plan
 *
 * Operation-based plan mutation. Supported operations: edit, add-section, remove-section, reorder-sections, regenerate, dismiss-stale, dismiss-all-stale. Returns the updated plan with plan_meta (duration budget, section limits). Returns 409 on version conflict, 404 if section not found.
 */
export const applyPlanOperationMutation = (
  options?: Partial<Options<ApplyPlanOperationData>>,
): UseMutationOptions<
  ApplyPlanOperationResult,
  DefaultError,
  Options<ApplyPlanOperationData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyPlanOperationResult,
    DefaultError,
    Options<ApplyPlanOperationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyPlanOperation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create an AI-generated interview plan
 *
 * Generates a complete interview plan using AI. May take up to 2 minutes.
 */
export const createInterviewPlanMutation = (
  options?: Partial<Options<CreateInterviewPlanData>>,
): UseMutationOptions<
  CreateInterviewPlanResponse,
  DefaultError,
  Options<CreateInterviewPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateInterviewPlanResponse,
    DefaultError,
    Options<CreateInterviewPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createInterviewPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate (or return existing) evaluation rubric for an interview plan
 *
 * Returns the existing rubric if present unless ``force_regenerate=true``. Otherwise calls the LLM to generate a new rubric, persists it to plan.params, and returns it. Generation can take 10–60s.
 */
export const generateInterviewPlanRubricMutation = (
  options?: Partial<Options<GenerateInterviewPlanRubricData>>,
): UseMutationOptions<
  GenerateInterviewPlanRubricResponse,
  DefaultError,
  Options<GenerateInterviewPlanRubricData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInterviewPlanRubricResponse,
    DefaultError,
    Options<GenerateInterviewPlanRubricData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInterviewPlanRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Manually replace the evaluation rubric for an interview plan
 *
 * Replaces the rubric on a plan with a hand-edited version. Criterion weights must sum to 1.0 (±0.01) — 422 otherwise.
 */
export const updateInterviewPlanRubricMutation = (
  options?: Partial<Options<UpdateInterviewPlanRubricData>>,
): UseMutationOptions<
  UpdateInterviewPlanRubricResponse,
  DefaultError,
  Options<UpdateInterviewPlanRubricData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateInterviewPlanRubricResponse,
    DefaultError,
    Options<UpdateInterviewPlanRubricData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateInterviewPlanRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save the planner wizard draft state for a job
 *
 * Idempotent full-state replacement of wizard fields on the Job row. Returns 409 if a plan already exists for the job (the draft is locked). Side effect: if Job.description is empty, the saved jd_text is mirrored into it — jobs created entirely through the wizard never went through POST /jobs.
 */
export const saveInterviewPlanDraftMutation = (
  options?: Partial<Options<SaveInterviewPlanDraftData>>,
): UseMutationOptions<
  SaveInterviewPlanDraftResponse,
  DefaultError,
  Options<SaveInterviewPlanDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveInterviewPlanDraftResponse,
    DefaultError,
    Options<SaveInterviewPlanDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveInterviewPlanDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Pass-through LLM call for the Question Generator sales-demo tool
 */
export const questionGeneratorLlmMutation = (
  options?: Partial<Options<QuestionGeneratorLlmData>>,
): UseMutationOptions<
  QuestionGeneratorLlmResponse,
  DefaultError,
  Options<QuestionGeneratorLlmData>
> => {
  const mutationOptions: UseMutationOptions<
    QuestionGeneratorLlmResponse,
    DefaultError,
    Options<QuestionGeneratorLlmData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await questionGeneratorLlm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest interview topics for a section
 */
export const suggestTopicsMutation = (
  options?: Partial<Options<SuggestTopicsData>>,
): UseMutationOptions<
  SuggestTopicsResponse,
  DefaultError,
  Options<SuggestTopicsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestTopicsResponse,
    DefaultError,
    Options<SuggestTopicsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestTopics({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest subtopics for a topic
 */
export const suggestSubtopicsMutation = (
  options?: Partial<Options<SuggestSubtopicsData>>,
): UseMutationOptions<
  SuggestSubtopicsResponse,
  DefaultError,
  Options<SuggestSubtopicsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestSubtopicsResponse,
    DefaultError,
    Options<SuggestSubtopicsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestSubtopics({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest interview questions for a section
 */
export const suggestQuestionsMutation = (
  options?: Partial<Options<SuggestQuestionsData>>,
): UseMutationOptions<
  SuggestQuestionsResponse,
  DefaultError,
  Options<SuggestQuestionsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestQuestionsResponse,
    DefaultError,
    Options<SuggestQuestionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestQuestions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regenerate case study content for a section
 */
export const regenerateCaseStudyMutation = (
  options?: Partial<Options<RegenerateCaseStudyData>>,
): UseMutationOptions<
  RegenerateCaseStudyResponse,
  DefaultError,
  Options<RegenerateCaseStudyData>
> => {
  const mutationOptions: UseMutationOptions<
    RegenerateCaseStudyResponse,
    DefaultError,
    Options<RegenerateCaseStudyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await regenerateCaseStudy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate a sample interactive coding problem
 */
export const generateInteractiveProblemMutation = (
  options?: Partial<Options<GenerateInteractiveProblemData>>,
): UseMutationOptions<
  GenerateInteractiveProblemResponse,
  DefaultError,
  Options<GenerateInteractiveProblemData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInteractiveProblemResponse,
    DefaultError,
    Options<GenerateInteractiveProblemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInteractiveProblem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest values for interactive coding config fields
 */
export const suggestInteractiveConfigMutation = (
  options?: Partial<Options<SuggestInteractiveConfigData>>,
): UseMutationOptions<
  SuggestInteractiveConfigResponse,
  DefaultError,
  Options<SuggestInteractiveConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestInteractiveConfigResponse,
    DefaultError,
    Options<SuggestInteractiveConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestInteractiveConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate evaluation criteria for a section
 */
export const generateSectionCriteriaMutation = (
  options?: Partial<Options<GenerateSectionCriteriaData>>,
): UseMutationOptions<
  GenerateSectionCriteriaResponse,
  DefaultError,
  Options<GenerateSectionCriteriaData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSectionCriteriaResponse,
    DefaultError,
    Options<GenerateSectionCriteriaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateSectionCriteria({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Expand a draft job description into a complete one
 */
export const expandJobDescriptionMutation = (
  options?: Partial<Options<ExpandJobDescriptionData>>,
): UseMutationOptions<
  ExpandJobDescriptionResponse,
  DefaultError,
  Options<ExpandJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    ExpandJobDescriptionResponse,
    DefaultError,
    Options<ExpandJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await expandJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refine an existing job description based on user feedback
 */
export const refineJobDescriptionMutation = (
  options?: Partial<Options<RefineJobDescriptionData>>,
): UseMutationOptions<
  RefineJobDescriptionResponse,
  DefaultError,
  Options<RefineJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    RefineJobDescriptionResponse,
    DefaultError,
    Options<RefineJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refineJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refine a selected portion of a job description
 */
export const refineJdSelectionMutation = (
  options?: Partial<Options<RefineJdSelectionData>>,
): UseMutationOptions<
  RefineJdSelectionResponse,
  DefaultError,
  Options<RefineJdSelectionData>
> => {
  const mutationOptions: UseMutationOptions<
    RefineJdSelectionResponse,
    DefaultError,
    Options<RefineJdSelectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refineJdSelection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getScreenerPlanQueryKey = (
  options: Options<GetScreenerPlanData>,
) => createQueryKey('getScreenerPlan', options);

/**
 * Get the active screener plan for a job
 */
export const getScreenerPlanOptions = (options: Options<GetScreenerPlanData>) =>
  queryOptions<
    GetScreenerPlanResponse,
    DefaultError,
    GetScreenerPlanResponse,
    ReturnType<typeof getScreenerPlanQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreenerPlan({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreenerPlanQueryKey(options),
  });

export const getScreeningApplicationsQueryKey = (
  options: Options<GetScreeningApplicationsData>,
) => createQueryKey('getScreeningApplications', options);

/**
 * List applications + their screener results for a job
 */
export const getScreeningApplicationsOptions = (
  options: Options<GetScreeningApplicationsData>,
) =>
  queryOptions<
    GetScreeningApplicationsResponse,
    DefaultError,
    GetScreeningApplicationsResponse,
    ReturnType<typeof getScreeningApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreeningApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreeningApplicationsQueryKey(options),
  });

export const getScreeningApplicationsInfiniteQueryKey = (
  options: Options<GetScreeningApplicationsData>,
): QueryKey<Options<GetScreeningApplicationsData>> =>
  createQueryKey('getScreeningApplications', options, true);

/**
 * List applications + their screener results for a job
 */
export const getScreeningApplicationsInfiniteOptions = (
  options: Options<GetScreeningApplicationsData>,
) =>
  infiniteQueryOptions<
    GetScreeningApplicationsResponse,
    DefaultError,
    InfiniteData<GetScreeningApplicationsResponse>,
    QueryKey<Options<GetScreeningApplicationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetScreeningApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetScreeningApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getScreeningApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getScreeningApplicationsInfiniteQueryKey(options),
    },
  );

export const getScreeningApplicationQueryKey = (
  options: Options<GetScreeningApplicationData>,
) => createQueryKey('getScreeningApplication', options);

/**
 * Get one screening application with all rubric results
 */
export const getScreeningApplicationOptions = (
  options: Options<GetScreeningApplicationData>,
) =>
  queryOptions<
    GetScreeningApplicationResponse,
    DefaultError,
    GetScreeningApplicationResponse,
    ReturnType<typeof getScreeningApplicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreeningApplication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreeningApplicationQueryKey(options),
  });

/**
 * Generate a fresh screener plan for a job (LLM-driven)
 */
export const createScreenerPlanMutation = (
  options?: Partial<Options<CreateScreenerPlanData>>,
): UseMutationOptions<
  CreateScreenerPlanResponse,
  DefaultError,
  Options<CreateScreenerPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateScreenerPlanResponse,
    DefaultError,
    Options<CreateScreenerPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createScreenerPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * In-place update of an active screener plan. Wipes Screening rows for re-evaluation.
 */
export const updateScreenerPlanMutation = (
  options?: Partial<Options<UpdateScreenerPlanData>>,
): UseMutationOptions<
  UpdateScreenerPlanResponse,
  DefaultError,
  Options<UpdateScreenerPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateScreenerPlanResponse,
    DefaultError,
    Options<UpdateScreenerPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateScreenerPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Fan out evaluation tasks across every application on the job
 */
export const evaluateScreenerJobMutation = (
  options?: Partial<Options<EvaluateScreenerJobData>>,
): UseMutationOptions<
  EvaluateScreenerJobResponse,
  DefaultError,
  Options<EvaluateScreenerJobData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateScreenerJobResponse,
    DefaultError,
    Options<EvaluateScreenerJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateScreenerJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Trigger evaluation for a single application
 */
export const evaluateScreenerApplicationMutation = (
  options?: Partial<Options<EvaluateScreenerApplicationData>>,
): UseMutationOptions<
  EvaluateScreenerApplicationResponse,
  DefaultError,
  Options<EvaluateScreenerApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateScreenerApplicationResponse,
    DefaultError,
    Options<EvaluateScreenerApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateScreenerApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPrescreenConversationQueryKey = (
  options: Options<GetPrescreenConversationData>,
) => createQueryKey('getPrescreenConversation', options);

/**
 * Get the candidate's prescreen conversation, or null when the job has none
 */
export const getPrescreenConversationOptions = (
  options: Options<GetPrescreenConversationData>,
) =>
  queryOptions<
    GetPrescreenConversationResponse,
    DefaultError,
    GetPrescreenConversationResponse,
    ReturnType<typeof getPrescreenConversationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationQueryKey(options),
  });

/**
 * Start Conversation
 */
export const startPrescreenConversationMutation = (
  options?: Partial<Options<StartPrescreenConversationData>>,
): UseMutationOptions<
  StartPrescreenConversationResponse,
  DefaultError,
  Options<StartPrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartPrescreenConversationResponse,
    DefaultError,
    Options<StartPrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startPrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete Conversation
 */
export const completePrescreenConversationMutation = (
  options?: Partial<Options<CompletePrescreenConversationData>>,
): UseMutationOptions<
  CompletePrescreenConversationResponse,
  DefaultError,
  Options<CompletePrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    CompletePrescreenConversationResponse,
    DefaultError,
    Options<CompletePrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completePrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPrescreenConversationDetailQueryKey = (
  options: Options<GetPrescreenConversationDetailData>,
) => createQueryKey('getPrescreenConversationDetail', options);

/**
 * Get the full conversation with transcript (recruiter)
 */
export const getPrescreenConversationDetailOptions = (
  options: Options<GetPrescreenConversationDetailData>,
) =>
  queryOptions<
    GetPrescreenConversationDetailResponse,
    DefaultError,
    GetPrescreenConversationDetailResponse,
    ReturnType<typeof getPrescreenConversationDetailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversationDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationDetailQueryKey(options),
  });

export const getPrescreenConversationsQueryKey = (
  options: Options<GetPrescreenConversationsData>,
) => createQueryKey('getPrescreenConversations', options);

/**
 * Conversation status for every application on a job (recruiter)
 */
export const getPrescreenConversationsOptions = (
  options: Options<GetPrescreenConversationsData>,
) =>
  queryOptions<
    GetPrescreenConversationsResponse,
    DefaultError,
    GetPrescreenConversationsResponse,
    ReturnType<typeof getPrescreenConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationsQueryKey(options),
  });

/**
 * Stop waiting on the candidate and screen them now (recruiter)
 */
export const forceReleasePrescreenConversationMutation = (
  options?: Partial<Options<ForceReleasePrescreenConversationData>>,
): UseMutationOptions<
  ForceReleasePrescreenConversationResponse,
  DefaultError,
  Options<ForceReleasePrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    ForceReleasePrescreenConversationResponse,
    DefaultError,
    Options<ForceReleasePrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await forceReleasePrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPublicJobsQueryKey = (options?: Options<ListPublicJobsData>) =>
  createQueryKey('listPublicJobs', options);

/**
 * List published jobs (public)
 */
export const listPublicJobsOptions = (options?: Options<ListPublicJobsData>) =>
  queryOptions<
    ListPublicJobsResult,
    DefaultError,
    ListPublicJobsResult,
    ReturnType<typeof listPublicJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPublicJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPublicJobsQueryKey(options),
  });

export const getPublicJobQueryKey = (options: Options<GetPublicJobData>) =>
  createQueryKey('getPublicJob', options);

/**
 * Get a published job (public)
 */
export const getPublicJobOptions = (options: Options<GetPublicJobData>) =>
  queryOptions<
    GetPublicJobResponse,
    DefaultError,
    GetPublicJobResponse,
    ReturnType<typeof getPublicJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicJobQueryKey(options),
  });

export const getJobLoginContextQueryKey = (
  options: Options<GetJobLoginContextData>,
) => createQueryKey('getJobLoginContext', options);

/**
 * Minimal pre-auth login-screen context for a job (works for unpublished invite-only jobs)
 */
export const getJobLoginContextOptions = (
  options: Options<GetJobLoginContextData>,
) =>
  queryOptions<
    GetJobLoginContextResponse,
    DefaultError,
    GetJobLoginContextResponse,
    ReturnType<typeof getJobLoginContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobLoginContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobLoginContextQueryKey(options),
  });

export const listMyJobsQueryKey = (options?: Options<ListMyJobsData>) =>
  createQueryKey('listMyJobs', options);

/**
 * List published jobs with candidate annotations (authenticated)
 */
export const listMyJobsOptions = (options?: Options<ListMyJobsData>) =>
  queryOptions<
    ListMyJobsResult,
    DefaultError,
    ListMyJobsResult,
    ReturnType<typeof listMyJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyJobsQueryKey(options),
  });

export const getMyJobQueryKey = (options: Options<GetMyJobData>) =>
  createQueryKey('getMyJob', options);

/**
 * Get a published job with full candidate detail (authenticated)
 */
export const getMyJobOptions = (options: Options<GetMyJobData>) =>
  queryOptions<
    GetMyJobResponse,
    DefaultError,
    GetMyJobResponse,
    ReturnType<typeof getMyJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyJobQueryKey(options),
  });

/**
 * Delete own application (candidate)
 */
export const deleteApplicationCandidateMutation = (
  options?: Partial<Options<DeleteApplicationCandidateData>>,
): UseMutationOptions<
  DeleteApplicationCandidateResponse,
  DefaultError,
  Options<DeleteApplicationCandidateData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApplicationCandidateResponse,
    DefaultError,
    Options<DeleteApplicationCandidateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteApplicationCandidate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Accept privacy policy for own application (candidate)
 */
export const acceptPrivacyPolicyMutation = (
  options?: Partial<Options<AcceptPrivacyPolicyData>>,
): UseMutationOptions<
  AcceptPrivacyPolicyResponse,
  DefaultError,
  Options<AcceptPrivacyPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptPrivacyPolicyResponse,
    DefaultError,
    Options<AcceptPrivacyPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptPrivacyPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Apply for a job — optional multipart resume upload
 */
export const applyForJobMutation = (
  options?: Partial<Options<ApplyForJobData>>,
): UseMutationOptions<
  ApplyForJobResult,
  DefaultError,
  Options<ApplyForJobData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyForJobResult,
    DefaultError,
    Options<ApplyForJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyForJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a resume for an existing application (multipart)
 */
export const uploadResumeForApplicationMutation = (
  options?: Partial<Options<UploadResumeForApplicationData>>,
): UseMutationOptions<
  UploadResumeForApplicationResponse,
  DefaultError,
  Options<UploadResumeForApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadResumeForApplicationResponse,
    DefaultError,
    Options<UploadResumeForApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadResumeForApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCandidateInterviewQueryKey = (
  options: Options<GetCandidateInterviewData>,
) => createQueryKey('getCandidateInterview', options);

/**
 * Get interview details for the candidate taking the interview
 *
 * Returns the meeting-critical interview payload for the authenticated candidate. Fails with 403 if the authenticated user does not own this interview. Includes a 2-hour signed GCS URL for the candidate's resume.
 */
export const getCandidateInterviewOptions = (
  options: Options<GetCandidateInterviewData>,
) =>
  queryOptions<
    GetCandidateInterviewResponse,
    DefaultError,
    GetCandidateInterviewResponse,
    ReturnType<typeof getCandidateInterviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateInterview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateInterviewQueryKey(options),
  });

export const listMyInterviewsQueryKey = (
  options?: Options<ListMyInterviewsData>,
) => createQueryKey('listMyInterviews', options);

/**
 * List all interviews for the authenticated candidate
 *
 * Returns all interviews belonging to the authenticated user across all tenants. Pass ?lockdown_browser_only=true to restrict to jobs with lockdown browser enabled (used by the desktop client). This query is intentionally cross-tenant: the desktop lockdown browser authenticates via the central auth subdomain, not the candidate's employer subdomain, so tenant filtering would silently return empty results for those clients.
 */
export const listMyInterviewsOptions = (
  options?: Options<ListMyInterviewsData>,
) =>
  queryOptions<
    ListMyInterviewsResult,
    DefaultError,
    ListMyInterviewsResult,
    ReturnType<typeof listMyInterviewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyInterviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyInterviewsQueryKey(options),
  });

export const getRecruiterInterviewQueryKey = (
  options: Options<GetRecruiterInterviewData>,
) => createQueryKey('getRecruiterInterview', options);

/**
 * Get interview details for a recruiter
 *
 * Returns the full interview detail for a recruiter, including candidate PII, the synthesized scorecard (criteria mapped from TOML evaluation_criteria), and a 2-hour signed GCS URL for the candidate's resume. Fails with 403 if the caller is not a tenant member.
 */
export const getRecruiterInterviewOptions = (
  options: Options<GetRecruiterInterviewData>,
) =>
  queryOptions<
    GetRecruiterInterviewResponse,
    DefaultError,
    GetRecruiterInterviewResponse,
    ReturnType<typeof getRecruiterInterviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecruiterInterview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRecruiterInterviewQueryKey(options),
  });

export const listInterviewsForJobQueryKey = (
  options: Options<ListInterviewsForJobData>,
) => createQueryKey('listInterviewsForJob', options);

/**
 * List interviews for a job (recruiter view)
 *
 * Returns a cursor-paginated list of interviews for the given job. Requires recruiter, hiring_manager, or Account Admin role. Pass ?tab= to filter by evaluation state. Pass ?intake_filters[batch]=<value> to filter by the batch field in intake metadata.
 */
export const listInterviewsForJobOptions = (
  options: Options<ListInterviewsForJobData>,
) =>
  queryOptions<
    ListInterviewsForJobResponse,
    DefaultError,
    ListInterviewsForJobResponse,
    ReturnType<typeof listInterviewsForJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewsForJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewsForJobQueryKey(options),
  });

export const listInterviewsForJobInfiniteQueryKey = (
  options: Options<ListInterviewsForJobData>,
): QueryKey<Options<ListInterviewsForJobData>> =>
  createQueryKey('listInterviewsForJob', options, true);

/**
 * List interviews for a job (recruiter view)
 *
 * Returns a cursor-paginated list of interviews for the given job. Requires recruiter, hiring_manager, or Account Admin role. Pass ?tab= to filter by evaluation state. Pass ?intake_filters[batch]=<value> to filter by the batch field in intake metadata.
 */
export const listInterviewsForJobInfiniteOptions = (
  options: Options<ListInterviewsForJobData>,
) =>
  infiniteQueryOptions<
    ListInterviewsForJobResponse,
    DefaultError,
    InfiniteData<ListInterviewsForJobResponse>,
    QueryKey<Options<ListInterviewsForJobData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListInterviewsForJobData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListInterviewsForJobData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInterviewsForJob({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listInterviewsForJobInfiniteQueryKey(options),
    },
  );

export const getInterviewResultQueryKey = (
  options?: Options<GetInterviewResultData>,
) => createQueryKey('getInterviewResult', options);

/**
 * Get interview result (session auth or share token)
 *
 * Two mutually exclusive access modes: pass `interview_id` for session-authenticated access (recruiter or candidate), or pass `token` for public share-link access. Exactly one must be provided.
 */
export const getInterviewResultOptions = (
  options?: Options<GetInterviewResultData>,
) =>
  queryOptions<
    GetInterviewResultResponse,
    DefaultError,
    GetInterviewResultResponse,
    ReturnType<typeof getInterviewResultQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewResultQueryKey(options),
  });

export const getProctoringClipUrlQueryKey = (
  options: Options<GetProctoringClipUrlData>,
) => createQueryKey('getProctoringClipUrl', options);

/**
 * Sign one proctoring clip URL on demand (session auth or share token)
 *
 * Returns a short-lived signed URL for a single proctoring clip, signed on demand when the clip modal opens (clips are no longer signed at result-assembly time). Same access modes as get_interview_result: `interview_id`/`application_id` for session auth, or `token` for a public share link. A clip withheld from the result payload (disputed on a public share, or proctoring hidden) returns `clip_url=null`, as does a missing clip.
 */
export const getProctoringClipUrlOptions = (
  options: Options<GetProctoringClipUrlData>,
) =>
  queryOptions<
    GetProctoringClipUrlResponse,
    DefaultError,
    GetProctoringClipUrlResponse,
    ReturnType<typeof getProctoringClipUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProctoringClipUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProctoringClipUrlQueryKey(options),
  });

/**
 * Generate a public share link for an interview result
 */
export const generateInterviewShareTokenMutation = (
  options?: Partial<Options<GenerateInterviewShareTokenData>>,
): UseMutationOptions<
  GenerateInterviewShareTokenResponse,
  DefaultError,
  Options<GenerateInterviewShareTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInterviewShareTokenResponse,
    DefaultError,
    Options<GenerateInterviewShareTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInterviewShareToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Manually (re)trigger AI proctoring for an interview (fail-safe)
 */
export const triggerInterviewProctoringMutation = (
  options?: Partial<Options<TriggerInterviewProctoringData>>,
): UseMutationOptions<
  TriggerInterviewProctoringResponse,
  DefaultError,
  Options<TriggerInterviewProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    TriggerInterviewProctoringResponse,
    DefaultError,
    Options<TriggerInterviewProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerInterviewProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Manually (re)trigger AI proctoring for many interviews in one request (fail-safe)
 */
export const triggerInterviewProctoringBulkMutation = (
  options?: Partial<Options<TriggerInterviewProctoringBulkData>>,
): UseMutationOptions<
  TriggerInterviewProctoringBulkResponse,
  DefaultError,
  Options<TriggerInterviewProctoringBulkData>
> => {
  const mutationOptions: UseMutationOptions<
    TriggerInterviewProctoringBulkResponse,
    DefaultError,
    Options<TriggerInterviewProctoringBulkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerInterviewProctoringBulk({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Recruiter records feedback on a proctoring flag (agree or disagree) and re-buckets the candidate
 */
export const recordProctoringFeedbackMutation = (
  options?: Partial<Options<RecordProctoringFeedbackData>>,
): UseMutationOptions<
  RecordProctoringFeedbackResult,
  DefaultError,
  Options<RecordProctoringFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordProctoringFeedbackResult,
    DefaultError,
    Options<RecordProctoringFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordProctoringFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const greenhouseListTestsQueryKey = (
  options?: Options<GreenhouseListTestsData>,
) => createQueryKey('greenhouseListTests', options);

/**
 * List available tests (jobs) for Greenhouse
 *
 * Returns active jobs as partner tests. Authentication: HMAC Basic Auth.
 */
export const greenhouseListTestsOptions = (
  options?: Options<GreenhouseListTestsData>,
) =>
  queryOptions<
    GreenhouseListTestsResponse,
    DefaultError,
    GreenhouseListTestsResponse,
    ReturnType<typeof greenhouseListTestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await greenhouseListTests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: greenhouseListTestsQueryKey(options),
  });

export const greenhouseTestStatusQueryKey = (
  options: Options<GreenhouseTestStatusData>,
) => createQueryKey('greenhouseTestStatus', options);

/**
 * Get interview status
 *
 * Returns partner status and results for a given interview ID. Greenhouse polls this.
 */
export const greenhouseTestStatusOptions = (
  options: Options<GreenhouseTestStatusData>,
) =>
  queryOptions<
    GreenhouseTestStatusResponse,
    DefaultError,
    GreenhouseTestStatusResponse,
    ReturnType<typeof greenhouseTestStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await greenhouseTestStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: greenhouseTestStatusQueryKey(options),
  });

/**
 * Send candidate to assessment
 *
 * Creates user, application, and interview for a Greenhouse candidate. Queues invitation email.
 */
export const greenhouseSendTestMutation = (
  options?: Partial<Options<GreenhouseSendTestData>>,
): UseMutationOptions<
  GreenhouseSendTestResponse,
  DefaultError,
  Options<GreenhouseSendTestData>
> => {
  const mutationOptions: UseMutationOptions<
    GreenhouseSendTestResponse,
    DefaultError,
    Options<GreenhouseSendTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await greenhouseSendTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Log errors from Greenhouse
 *
 * Receives error reports from Greenhouse. Logs and returns 200.
 */
export const greenhouseRequestErrorsMutation = (
  options?: Partial<Options<GreenhouseRequestErrorsData>>,
): UseMutationOptions<
  GreenhouseRequestErrorsResponse,
  DefaultError,
  Options<GreenhouseRequestErrorsData>
> => {
  const mutationOptions: UseMutationOptions<
    GreenhouseRequestErrorsResponse,
    DefaultError,
    Options<GreenhouseRequestErrorsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await greenhouseRequestErrors({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCreateJobDraftQueryKey = (
  options: Options<GetCreateJobDraftData>,
) => createQueryKey('getCreateJobDraft', options);

/**
 * Load wizard draft state for a job
 */
export const getCreateJobDraftOptions = (
  options: Options<GetCreateJobDraftData>,
) =>
  queryOptions<
    GetCreateJobDraftResponse,
    DefaultError,
    GetCreateJobDraftResponse,
    ReturnType<typeof getCreateJobDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCreateJobDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCreateJobDraftQueryKey(options),
  });

/**
 * Upsert wizard draft state (409 if already confirmed)
 */
export const saveCreateJobDraftMutation = (
  options?: Partial<Options<SaveCreateJobDraftData>>,
): UseMutationOptions<
  SaveCreateJobDraftResponse,
  DefaultError,
  Options<SaveCreateJobDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveCreateJobDraftResponse,
    DefaultError,
    Options<SaveCreateJobDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveCreateJobDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Lock draft and generate interview plan (blocking, ~4 min)
 */
export const confirmCreateJobMutation = (
  options?: Partial<Options<ConfirmCreateJobData>>,
): UseMutationOptions<
  ConfirmCreateJobResponse,
  DefaultError,
  Options<ConfirmCreateJobData>
> => {
  const mutationOptions: UseMutationOptions<
    ConfirmCreateJobResponse,
    DefaultError,
    Options<ConfirmCreateJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmCreateJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Read-only: which of the supplied emails already have an active interview for this job
 */
export const checkAlreadyInSystemMutation = (
  options?: Partial<Options<CheckAlreadyInSystemData>>,
): UseMutationOptions<
  CheckAlreadyInSystemResult,
  DefaultError,
  Options<CheckAlreadyInSystemData>
> => {
  const mutationOptions: UseMutationOptions<
    CheckAlreadyInSystemResult,
    DefaultError,
    Options<CheckAlreadyInSystemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkAlreadyInSystem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCandidateIntakeValidationStatusQueryKey = (
  options: Options<GetCandidateIntakeValidationStatusData>,
) => createQueryKey('getCandidateIntakeValidationStatus', options);

/**
 * Poll status + progress of an in-flight or completed validation task
 */
export const getCandidateIntakeValidationStatusOptions = (
  options: Options<GetCandidateIntakeValidationStatusData>,
) =>
  queryOptions<
    GetCandidateIntakeValidationStatusResponse,
    DefaultError,
    GetCandidateIntakeValidationStatusResponse,
    ReturnType<typeof getCandidateIntakeValidationStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateIntakeValidationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateIntakeValidationStatusQueryKey(options),
  });

/**
 * Bulk-create screening-stage applications for a job
 */
export const bulkScreeningIntakeMutation = (
  options?: Partial<Options<BulkScreeningIntakeData>>,
): UseMutationOptions<
  BulkScreeningIntakeResult,
  DefaultError,
  Options<BulkScreeningIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkScreeningIntakeResult,
    DefaultError,
    Options<BulkScreeningIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkScreeningIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk-create interview-stage applications + Interview rows for a job
 */
export const bulkInterviewIntakeMutation = (
  options?: Partial<Options<BulkInterviewIntakeData>>,
): UseMutationOptions<
  BulkInterviewIntakeResult,
  DefaultError,
  Options<BulkInterviewIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkInterviewIntakeResult,
    DefaultError,
    Options<BulkInterviewIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkInterviewIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Move RESUME_SCREENING applications to INTERVIEWING and optionally fire invite emails
 */
export const inviteToInterviewMutation = (
  options?: Partial<Options<InviteToInterviewData>>,
): UseMutationOptions<
  InviteToInterviewResult,
  DefaultError,
  Options<InviteToInterviewData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteToInterviewResult,
    DefaultError,
    Options<InviteToInterviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteToInterview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Move CREATED applications to INVITED_FOR_ASSESSMENT and optionally fire invite emails
 */
export const inviteToAssessmentMutation = (
  options?: Partial<Options<InviteToAssessmentData>>,
): UseMutationOptions<
  InviteToAssessmentResult,
  DefaultError,
  Options<InviteToAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteToAssessmentResult,
    DefaultError,
    Options<InviteToAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteToAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk-create assessment-stage applications for a job (create + invite, skipping screening)
 */
export const bulkAssessmentIntakeMutation = (
  options?: Partial<Options<BulkAssessmentIntakeData>>,
): UseMutationOptions<
  BulkAssessmentIntakeResult,
  DefaultError,
  Options<BulkAssessmentIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkAssessmentIntakeResult,
    DefaultError,
    Options<BulkAssessmentIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkAssessmentIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one screening-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleScreeningIntakeMutation = (
  options?: Partial<Options<SingleScreeningIntakeData>>,
): UseMutationOptions<
  SingleScreeningIntakeResult,
  DefaultError,
  Options<SingleScreeningIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleScreeningIntakeResult,
    DefaultError,
    Options<SingleScreeningIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleScreeningIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one interview-stage application + Interview row for a job (multipart: request JSON + optional resume file)
 */
export const singleInterviewIntakeMutation = (
  options?: Partial<Options<SingleInterviewIntakeData>>,
): UseMutationOptions<
  SingleInterviewIntakeResult,
  DefaultError,
  Options<SingleInterviewIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleInterviewIntakeResult,
    DefaultError,
    Options<SingleInterviewIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleInterviewIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one assessment-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleAssessmentIntakeMutation = (
  options?: Partial<Options<SingleAssessmentIntakeData>>,
): UseMutationOptions<
  SingleAssessmentIntakeResult,
  DefaultError,
  Options<SingleAssessmentIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleAssessmentIntakeResult,
    DefaultError,
    Options<SingleAssessmentIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleAssessmentIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kick off async validation of a candidate-intake spreadsheet or resume ZIP
 */
export const startCandidateIntakeValidationMutation = (
  options?: Partial<Options<StartCandidateIntakeValidationData>>,
): UseMutationOptions<
  StartCandidateIntakeValidationResponse,
  DefaultError,
  Options<StartCandidateIntakeValidationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCandidateIntakeValidationResponse,
    DefaultError,
    Options<StartCandidateIntakeValidationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCandidateIntakeValidation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Parse a single PDF/DOCX resume into structured candidate fields
 */
export const parseCandidateResumeMutation = (
  options?: Partial<Options<ParseCandidateResumeData>>,
): UseMutationOptions<
  ParseCandidateResumeResponse,
  DefaultError,
  Options<ParseCandidateResumeData>
> => {
  const mutationOptions: UseMutationOptions<
    ParseCandidateResumeResponse,
    DefaultError,
    Options<ParseCandidateResumeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await parseCandidateResume({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJobAnalyticsQueryKey = (
  options: Options<GetJobAnalyticsData>,
) => createQueryKey('getJobAnalytics', options);

/**
 * Comprehensive analytics for a job
 */
export const getJobAnalyticsOptions = (options: Options<GetJobAnalyticsData>) =>
  queryOptions<
    GetJobAnalyticsResponse,
    DefaultError,
    GetJobAnalyticsResponse,
    ReturnType<typeof getJobAnalyticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalytics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsQueryKey(options),
  });

export const getJobAnalyticsBatchesQueryKey = (
  options: Options<GetJobAnalyticsBatchesData>,
) => createQueryKey('getJobAnalyticsBatches', options);

/**
 * Distinct batch values for the job filter dropdown
 */
export const getJobAnalyticsBatchesOptions = (
  options: Options<GetJobAnalyticsBatchesData>,
) =>
  queryOptions<
    GetJobAnalyticsBatchesResponse,
    DefaultError,
    GetJobAnalyticsBatchesResponse,
    ReturnType<typeof getJobAnalyticsBatchesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalyticsBatches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsBatchesQueryKey(options),
  });

export const getJobAnalyticsExcelQueryKey = (
  options: Options<GetJobAnalyticsExcelData>,
) => createQueryKey('getJobAnalyticsExcel', options);

/**
 * Download analytics as a multi-sheet Excel workbook
 */
export const getJobAnalyticsExcelOptions = (
  options: Options<GetJobAnalyticsExcelData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getJobAnalyticsExcelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalyticsExcel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsExcelQueryKey(options),
  });

export const getConsumptionReportQueryKey = (
  options?: Options<GetConsumptionReportData>,
) => createQueryKey('getConsumptionReport', options);

/**
 * Download tenant consumption report
 */
export const getConsumptionReportOptions = (
  options?: Options<GetConsumptionReportData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getConsumptionReportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConsumptionReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getConsumptionReportQueryKey(options),
  });

export const getUsageAnalyticsQueryKey = (
  options?: Options<GetUsageAnalyticsData>,
) => createQueryKey('getUsageAnalytics', options);

/**
 * Get consumption analytics for the tenant
 */
export const getUsageAnalyticsOptions = (
  options?: Options<GetUsageAnalyticsData>,
) =>
  queryOptions<
    GetUsageAnalyticsResponse,
    DefaultError,
    GetUsageAnalyticsResponse,
    ReturnType<typeof getUsageAnalyticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsageAnalytics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUsageAnalyticsQueryKey(options),
  });

export const generateInkeepTokenQueryKey = (
  options?: Options<GenerateInkeepTokenData>,
) => createQueryKey('generateInkeepToken', options);

/**
 * Generate a short-lived JWT for Inkeep agents-api authentication
 *
 * Returns a 30-minute HS256 JWT signed with the platform secret key. The Inkeep agents-api verifies this token (via DJANGO_SECRET_KEY env var) to authenticate support-chat requests without a session cookie proxy.
 */
export const generateInkeepTokenOptions = (
  options?: Options<GenerateInkeepTokenData>,
) =>
  queryOptions<
    GenerateInkeepTokenResponse,
    DefaultError,
    GenerateInkeepTokenResponse,
    ReturnType<typeof generateInkeepTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateInkeepToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: generateInkeepTokenQueryKey(options),
  });

/**
 * Execute Task
 */
export const executeTaskTasksExecutePostMutation = (
  options?: Partial<Options<ExecuteTaskTasksExecutePostData>>,
): UseMutationOptions<
  ExecuteTaskTasksExecutePostResponse,
  ExecuteTaskTasksExecutePostError,
  Options<ExecuteTaskTasksExecutePostData>
> => {
  const mutationOptions: UseMutationOptions<
    ExecuteTaskTasksExecutePostResponse,
    ExecuteTaskTasksExecutePostError,
    Options<ExecuteTaskTasksExecutePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await executeTaskTasksExecutePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Provision a partner API credential
 *
 * Creates the service account, role and membership if absent, then mints a key. Idempotent.
 */
export const createPartnerCredentialMutation = (
  options?: Partial<Options<CreatePartnerCredentialData>>,
): UseMutationOptions<
  CreatePartnerCredentialResult,
  DefaultError,
  Options<CreatePartnerCredentialData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePartnerCredentialResult,
    DefaultError,
    Options<CreatePartnerCredentialData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPartnerCredential({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWorkflowAvailableEventsQueryKey = (
  options: Options<GetWorkflowAvailableEventsData>,
) => createQueryKey('getWorkflowAvailableEvents', options);

/**
 * Get Available Events
 */
export const getWorkflowAvailableEventsOptions = (
  options: Options<GetWorkflowAvailableEventsData>,
) =>
  queryOptions<
    GetWorkflowAvailableEventsResponse,
    DefaultError,
    GetWorkflowAvailableEventsResponse,
    ReturnType<typeof getWorkflowAvailableEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowAvailableEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowAvailableEventsQueryKey(options),
  });

export const getWorkflowAuditHistoryQueryKey = (
  options: Options<GetWorkflowAuditHistoryData>,
) => createQueryKey('getWorkflowAuditHistory', options);

/**
 * Get Audit History
 */
export const getWorkflowAuditHistoryOptions = (
  options: Options<GetWorkflowAuditHistoryData>,
) =>
  queryOptions<
    GetWorkflowAuditHistoryResponse,
    DefaultError,
    GetWorkflowAuditHistoryResponse,
    ReturnType<typeof getWorkflowAuditHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowAuditHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowAuditHistoryQueryKey(options),
  });

/**
 * Get Bulk Available Events
 */
export const getWorkflowBulkAvailableEventsMutation = (
  options?: Partial<Options<GetWorkflowBulkAvailableEventsData>>,
): UseMutationOptions<
  GetWorkflowBulkAvailableEventsResponse,
  DefaultError,
  Options<GetWorkflowBulkAvailableEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    GetWorkflowBulkAvailableEventsResponse,
    DefaultError,
    Options<GetWorkflowBulkAvailableEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await getWorkflowBulkAvailableEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transition
 */
export const workflowTransitionMutation = (
  options?: Partial<Options<WorkflowTransitionData>>,
): UseMutationOptions<
  WorkflowTransitionResponse,
  DefaultError,
  Options<WorkflowTransitionData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowTransitionResponse,
    DefaultError,
    Options<WorkflowTransitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowTransition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Transition
 */
export const workflowBulkTransitionMutation = (
  options?: Partial<Options<WorkflowBulkTransitionData>>,
): UseMutationOptions<
  WorkflowBulkTransitionResponse,
  DefaultError,
  Options<WorkflowBulkTransitionData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkTransitionResponse,
    DefaultError,
    Options<WorkflowBulkTransitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkTransition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Submit Human Review
 */
export const workflowSubmitHumanReviewMutation = (
  options?: Partial<Options<WorkflowSubmitHumanReviewData>>,
): UseMutationOptions<
  WorkflowSubmitHumanReviewResponse,
  DefaultError,
  Options<WorkflowSubmitHumanReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowSubmitHumanReviewResponse,
    DefaultError,
    Options<WorkflowSubmitHumanReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowSubmitHumanReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign Reviewer
 */
export const workflowAssignReviewerMutation = (
  options?: Partial<Options<WorkflowAssignReviewerData>>,
): UseMutationOptions<
  WorkflowAssignReviewerResponse,
  DefaultError,
  Options<WorkflowAssignReviewerData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowAssignReviewerResponse,
    DefaultError,
    Options<WorkflowAssignReviewerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowAssignReviewer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Assign Reviewer
 */
export const workflowBulkAssignReviewerMutation = (
  options?: Partial<Options<WorkflowBulkAssignReviewerData>>,
): UseMutationOptions<
  WorkflowBulkAssignReviewerResponse,
  DefaultError,
  Options<WorkflowBulkAssignReviewerData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkAssignReviewerResponse,
    DefaultError,
    Options<WorkflowBulkAssignReviewerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkAssignReviewer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Assign By Added By
 */
export const workflowBulkAssignByAddedByMutation = (
  options?: Partial<Options<WorkflowBulkAssignByAddedByData>>,
): UseMutationOptions<
  WorkflowBulkAssignByAddedByResponse,
  DefaultError,
  Options<WorkflowBulkAssignByAddedByData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkAssignByAddedByResponse,
    DefaultError,
    Options<WorkflowBulkAssignByAddedByData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkAssignByAddedBy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Send Reminder
 */
export const workflowBulkSendReminderMutation = (
  options?: Partial<Options<WorkflowBulkSendReminderData>>,
): UseMutationOptions<
  WorkflowBulkSendReminderResponse,
  DefaultError,
  Options<WorkflowBulkSendReminderData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkSendReminderResponse,
    DefaultError,
    Options<WorkflowBulkSendReminderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkSendReminder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Change Deadline
 */
export const workflowBulkChangeDeadlineMutation = (
  options?: Partial<Options<WorkflowBulkChangeDeadlineData>>,
): UseMutationOptions<
  WorkflowBulkChangeDeadlineResponse,
  DefaultError,
  Options<WorkflowBulkChangeDeadlineData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkChangeDeadlineResponse,
    DefaultError,
    Options<WorkflowBulkChangeDeadlineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkChangeDeadline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCodingAssessmentPreviewQueryKey = (
  options: Options<GetCodingAssessmentPreviewData>,
) => createQueryKey('getCodingAssessmentPreview', options);

/**
 * Get Assessment Preview
 */
export const getCodingAssessmentPreviewOptions = (
  options: Options<GetCodingAssessmentPreviewData>,
) =>
  queryOptions<
    GetCodingAssessmentPreviewResponse,
    DefaultError,
    GetCodingAssessmentPreviewResponse,
    ReturnType<typeof getCodingAssessmentPreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCodingAssessmentPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCodingAssessmentPreviewQueryKey(options),
  });

/**
 * Start Assessment
 */
export const startCodingAssessmentMutation = (
  options?: Partial<Options<StartCodingAssessmentData>>,
): UseMutationOptions<
  StartCodingAssessmentResponse,
  DefaultError,
  Options<StartCodingAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCodingAssessmentResponse,
    DefaultError,
    Options<StartCodingAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCodingAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start the candidate's clock at the moment the editor appears, not at /start
 */
export const markCodingAssessmentEditorLoadedMutation = (
  options?: Partial<Options<MarkCodingAssessmentEditorLoadedData>>,
): UseMutationOptions<
  MarkCodingAssessmentEditorLoadedResponse,
  DefaultError,
  Options<MarkCodingAssessmentEditorLoadedData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkCodingAssessmentEditorLoadedResponse,
    DefaultError,
    Options<MarkCodingAssessmentEditorLoadedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markCodingAssessmentEditorLoaded({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sync Draft
 */
export const syncCodingAssessmentDraftMutation = (
  options?: Partial<Options<SyncCodingAssessmentDraftData>>,
): UseMutationOptions<
  SyncCodingAssessmentDraftResponse,
  DefaultError,
  Options<SyncCodingAssessmentDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    SyncCodingAssessmentDraftResponse,
    DefaultError,
    Options<SyncCodingAssessmentDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await syncCodingAssessmentDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Run Code
 */
export const runCodingAssessmentCodeMutation = (
  options?: Partial<Options<RunCodingAssessmentCodeData>>,
): UseMutationOptions<
  RunCodingAssessmentCodeResponse,
  DefaultError,
  Options<RunCodingAssessmentCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    RunCodingAssessmentCodeResponse,
    DefaultError,
    Options<RunCodingAssessmentCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await runCodingAssessmentCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Submit Code
 */
export const submitCodingAssessmentCodeMutation = (
  options?: Partial<Options<SubmitCodingAssessmentCodeData>>,
): UseMutationOptions<
  SubmitCodingAssessmentCodeResponse,
  DefaultError,
  Options<SubmitCodingAssessmentCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitCodingAssessmentCodeResponse,
    DefaultError,
    Options<SubmitCodingAssessmentCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitCodingAssessmentCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCodingAssessmentExecutionStatusQueryKey = (
  options: Options<GetCodingAssessmentExecutionStatusData>,
) => createQueryKey('getCodingAssessmentExecutionStatus', options);

/**
 * Get Execution Status
 */
export const getCodingAssessmentExecutionStatusOptions = (
  options: Options<GetCodingAssessmentExecutionStatusData>,
) =>
  queryOptions<
    GetCodingAssessmentExecutionStatusResponse,
    DefaultError,
    GetCodingAssessmentExecutionStatusResponse,
    ReturnType<typeof getCodingAssessmentExecutionStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCodingAssessmentExecutionStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCodingAssessmentExecutionStatusQueryKey(options),
  });

export const listCodingAssessmentSubmissionsQueryKey = (
  options: Options<ListCodingAssessmentSubmissionsData>,
) => createQueryKey('listCodingAssessmentSubmissions', options);

/**
 * List Submissions
 */
export const listCodingAssessmentSubmissionsOptions = (
  options: Options<ListCodingAssessmentSubmissionsData>,
) =>
  queryOptions<
    ListCodingAssessmentSubmissionsResponse,
    DefaultError,
    ListCodingAssessmentSubmissionsResponse,
    ReturnType<typeof listCodingAssessmentSubmissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCodingAssessmentSubmissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCodingAssessmentSubmissionsQueryKey(options),
  });

/**
 * Complete Assessment
 */
export const completeCodingAssessmentMutation = (
  options?: Partial<Options<CompleteCodingAssessmentData>>,
): UseMutationOptions<
  CompleteCodingAssessmentResponse,
  DefaultError,
  Options<CompleteCodingAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteCodingAssessmentResponse,
    DefaultError,
    Options<CompleteCodingAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeCodingAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Batch-ingest candidate-emitted proctoring events (behavioral signals + real-time violations)
 */
export const recordCodingAssessmentEventsMutation = (
  options?: Partial<Options<RecordCodingAssessmentEventsData>>,
): UseMutationOptions<
  RecordCodingAssessmentEventsResponse,
  DefaultError,
  Options<RecordCodingAssessmentEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordCodingAssessmentEventsResponse,
    DefaultError,
    Options<RecordCodingAssessmentEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordCodingAssessmentEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Recording Session
 */
export const createCodingAssessmentRecordingSessionMutation = (
  options?: Partial<Options<CreateCodingAssessmentRecordingSessionData>>,
): UseMutationOptions<
  CreateCodingAssessmentRecordingSessionResponse,
  DefaultError,
  Options<CreateCodingAssessmentRecordingSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCodingAssessmentRecordingSessionResponse,
    DefaultError,
    Options<CreateCodingAssessmentRecordingSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCodingAssessmentRecordingSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAssessmentApplicationsQueryKey = (
  options: Options<GetAssessmentApplicationsData>,
) => createQueryKey('getAssessmentApplications', options);

/**
 * List assessment-round applications for a job, or one application in full when application_id is given
 */
export const getAssessmentApplicationsOptions = (
  options: Options<GetAssessmentApplicationsData>,
) =>
  queryOptions<
    GetAssessmentApplicationsResponse,
    DefaultError,
    GetAssessmentApplicationsResponse,
    ReturnType<typeof getAssessmentApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentApplicationsQueryKey(options),
  });

export const getAssessmentApplicationsInfiniteQueryKey = (
  options: Options<GetAssessmentApplicationsData>,
): QueryKey<Options<GetAssessmentApplicationsData>> =>
  createQueryKey('getAssessmentApplications', options, true);

/**
 * List assessment-round applications for a job, or one application in full when application_id is given
 */
export const getAssessmentApplicationsInfiniteOptions = (
  options: Options<GetAssessmentApplicationsData>,
) =>
  infiniteQueryOptions<
    GetAssessmentApplicationsResponse,
    DefaultError,
    InfiniteData<GetAssessmentApplicationsResponse>,
    QueryKey<Options<GetAssessmentApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetAssessmentApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetAssessmentApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAssessmentApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getAssessmentApplicationsInfiniteQueryKey(options),
    },
  );

export const getAssessmentRecordingUrlQueryKey = (
  options: Options<GetAssessmentRecordingUrlData>,
) => createQueryKey('getAssessmentRecordingUrl', options);

/**
 * Signed recording for one application (single camera url or multi-track manifest); separate from detail because the storage lookup is slow
 */
export const getAssessmentRecordingUrlOptions = (
  options: Options<GetAssessmentRecordingUrlData>,
) =>
  queryOptions<
    GetAssessmentRecordingUrlResponse,
    DefaultError,
    GetAssessmentRecordingUrlResponse,
    ReturnType<typeof getAssessmentRecordingUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentRecordingUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentRecordingUrlQueryKey(options),
  });

export const getAssessmentConfigQueryKey = (
  options: Options<GetAssessmentConfigData>,
) => createQueryKey('getAssessmentConfig', options);

/**
 * Get the recruiter-configured assessment template for a job, if any
 */
export const getAssessmentConfigOptions = (
  options: Options<GetAssessmentConfigData>,
) =>
  queryOptions<
    GetAssessmentConfigResult,
    DefaultError,
    GetAssessmentConfigResult,
    ReturnType<typeof getAssessmentConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentConfigQueryKey(options),
  });

/**
 * Save the recruiter-configured assessment template for a job
 */
export const saveAssessmentConfigMutation = (
  options?: Partial<Options<SaveAssessmentConfigData>>,
): UseMutationOptions<
  SaveAssessmentConfigResponse,
  DefaultError,
  Options<SaveAssessmentConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveAssessmentConfigResponse,
    DefaultError,
    Options<SaveAssessmentConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAssessmentConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const suggestAssessmentDesignQueryKey = (
  options: Options<SuggestAssessmentDesignData>,
) => createQueryKey('suggestAssessmentDesign', options);

/**
 * Suggest a first assessment design from the job description, unsaved
 */
export const suggestAssessmentDesignOptions = (
  options: Options<SuggestAssessmentDesignData>,
) =>
  queryOptions<
    SuggestAssessmentDesignResult,
    DefaultError,
    SuggestAssessmentDesignResult,
    ReturnType<typeof suggestAssessmentDesignQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await suggestAssessmentDesign({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: suggestAssessmentDesignQueryKey(options),
  });

export const getProblemTopicsQueryKey = (
  options: Options<GetProblemTopicsData>,
) => createQueryKey('getProblemTopics', options);

/**
 * List the topics a problem slot can draw from at one difficulty, with pool sizes
 */
export const getProblemTopicsOptions = (
  options: Options<GetProblemTopicsData>,
) =>
  queryOptions<
    GetProblemTopicsResponse,
    DefaultError,
    GetProblemTopicsResponse,
    ReturnType<typeof getProblemTopicsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProblemTopics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProblemTopicsQueryKey(options),
  });

/**
 * Save what the recruiter wants this round to reflect
 */
export const saveAssessmentRequirementsMutation = (
  options?: Partial<Options<SaveAssessmentRequirementsData>>,
): UseMutationOptions<
  SaveAssessmentRequirementsResponse,
  DefaultError,
  Options<SaveAssessmentRequirementsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveAssessmentRequirementsResponse,
    DefaultError,
    Options<SaveAssessmentRequirementsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAssessmentRequirements({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey('getCurrentUser', options);

/**
 * Get the authenticated caller's identity
 *
 * Returns the authenticated user's {id, name, email} resolved from the request principal (no DB read). Replaces the legacy `/api/users/?search=<email>` self-lookup.
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) =>
  queryOptions<
    GetCurrentUserResponse,
    DefaultError,
    GetCurrentUserResponse,
    ReturnType<typeof getCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserQueryKey(options),
  });

export const v2HealthHealthGetQueryKey = (
  options?: Options<V2HealthHealthGetData>,
) => createQueryKey('v2HealthHealthGet', options);

/**
 * V2 Health
 */
export const v2HealthHealthGetOptions = (
  options?: Options<V2HealthHealthGetData>,
) =>
  queryOptions<
    V2HealthHealthGetResponse,
    DefaultError,
    V2HealthHealthGetResponse,
    ReturnType<typeof v2HealthHealthGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await v2HealthHealthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: v2HealthHealthGetQueryKey(options),
  });
